/**
 * @file Generated by js-routes 2.4.1. Based on Rails 8.1.3.1 routes of GreenarrowStudio::Application.
 * @version 5be593b6651f6c999646be1c4f95ce221a3af8ae68548c4d3ecfff04fcea6db2
 * @see https://github.com/railsware/js-routes
 */
(() => {
    var _a;
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
const Router = (() => {
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class Router {
        constructor(config = {}) {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "__options__",
                serializer: this.default_serializer.bind(this),
                deprecated_false_parameter_behavior: false,
                deprecated_nil_query_parameter_behavior: false,
                include_undefined_query_parameters: true,
            };
            this.configure(config);
        }
        configure(new_config) {
            var _a;
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            (_a = new_config.serializer) !== null && _a !== void 0 ? _a : (new_config.serializer = this.default_serializer.bind(this));
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        __route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        default_serializer(value, prefix, array_element = false) {
            if (!prefix && !this.is_object(value)) {
                throw new Error("URL parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                // Rails serializes an empty array nested inside another array as a nil
                // query value, while an empty object contributes no query parameter.
                if (value.length === 0) {
                    return array_element
                        ? this.default_serializer(null, prefix + "[]")
                        : "";
                }
                for (const element of value) {
                    const subvalue = this.default_serializer(element, prefix + "[]", true);
                    // Skip empty object results so arrays do not produce leading,
                    // trailing, or doubled "&" separators.
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!this.hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (!this.configuration.include_undefined_query_parameters &&
                        prop === undefined) {
                        continue;
                    }
                    if (prefix) {
                        key = prefix + "[" + key + "]";
                    }
                    const subvalue = this.default_serializer(prop, key);
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else {
                const key = encodeURIComponent(prefix);
                result.push(this.is_not_nullable(value) ||
                    this.configuration.deprecated_nil_query_parameter_behavior
                    ? key + "=" + encodeURIComponent("" + (value !== null && value !== void 0 ? value : ""))
                    : key);
            }
            return result.join("&");
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) && !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (this.configuration.deprecated_false_parameter_behavior &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!this.hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!this.hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!this.hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !this.hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        hasProp(value, key) {
            return Object.prototype.hasOwnProperty.call(value, key);
        }
    }
    return Router;
})();
;
    const Modules = {
        references: {
            CJS: {
                define(routes) {
                    if (module) {
                        // Some javascript processors (like vite/rolldown)
                        // warn on using module dot exports in an ESM module.
                        // This just obfuscates that assignment a little so
                        // users don't get a warning they can't fix.
                        const _mod = module;
                        _mod.exports = routes;
                    }
                },
                isSupported() {
                    return typeof module === "object";
                },
            },
            AMD: {
                define(routes) {
                    if (define) {
                        define([], function () {
                            return routes;
                        });
                    }
                },
                isSupported() {
                    return typeof define === "function" && !!define.amd;
                },
            },
            UMD: {
                define(routes) {
                    if (Modules.references.AMD.isSupported()) {
                        Modules.references.AMD.define(routes);
                    }
                    else {
                        if (Modules.references.CJS.isSupported()) {
                            try {
                                Modules.references.CJS.define(routes);
                            }
                            catch (error) {
                                if (error.name !== "TypeError")
                                    throw error;
                            }
                        }
                    }
                },
                isSupported() {
                    return (Modules.references.AMD.isSupported() ||
                        Modules.references.CJS.isSupported());
                },
            },
            ESM: {
                define() {
                    // Module can only be defined using ruby code generation
                },
                isSupported() {
                    // Its impossible to check if "export" keyword is supported
                    return true;
                },
            },
            NIL: {
                define() {
                    // Defined using RubyVariables . WRAPPER
                },
                isSupported() {
                    return true;
                },
            },
            DTS: {
                // Acts the same as ESM
                define(routes) {
                    Modules.references.ESM.define(routes);
                },
                isSupported() {
                    return Modules.references.ESM.isSupported();
                },
            },
            PKG: {
                // Acts the same as ESM
                define() {
                    Modules.references.ESM.define(new Router());
                },
                isSupported() {
                    return Modules.references.ESM.isSupported();
                },
            },
        },
        is_module_supported(name) {
            return this.references[name].isSupported();
        },
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        },
        define_module(name, module) {
            this.ensure_module_supported(name);
            this.references[name].define(module);
            return module;
        },
    };
    const router = new Router({
        prefix: "/ga",
        default_url_options: {},
        special_options_key: "_options",
        serializer: (_a = null) !== null && _a !== void 0 ? _a : undefined,
        deprecated_false_parameter_behavior: false,
        deprecated_nil_query_parameter_behavior: false,
        include_undefined_query_parameters: true,
    });
    const __route = router.__route.bind(router);
    return Modules.define_module("CJS", {
        __route,
        configure: router.configure.bind(router),
        config: router.config.bind(router),
        serialize: router.serialize.bind(router),
        ...{
  /**
   * Generates rails route to
   * /api/organizations/:id/add_sending_credits(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  add_sending_credits_api_organization_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_sending_credits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/organizations/:id/add_sending_credits(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  add_sending_credits_api_v2_organization_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_sending_credits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /agree_to_terms_and_conditions/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  agree_to_terms_and_condition_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agree_to_terms_and_conditions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /agree_to_terms_and_conditions(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  agree_to_terms_and_conditions_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"agree_to_terms_and_conditions"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/alias_domains/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  alias_domain_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"alias_domains"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/alias_domains(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  alias_domains_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"alias_domains"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/jobs/all(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  all_api_jobs_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"all"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/organizations/:organization_id/jobs/all(.:format)
   * @param {any} organization_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  all_api_organization_jobs_path: __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"all"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/jobs/all(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  all_api_v2_jobs_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"all"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/organizations/:organization_id/jobs/all(.:format)
   * @param {any} organization_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  all_api_v2_organization_jobs_path: __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"all"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /jobs/all(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  all_jobs_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"all"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /api/jobs/all_on_all_organizations(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  all_on_all_organizations_api_jobs_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"all_on_all_organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/jobs/all_on_all_organizations(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  all_on_all_organizations_api_v2_jobs_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"all_on_all_organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/api_keys/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_api_key_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"api_keys"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/api_keys(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_api_keys_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"api_keys"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /api/bounce_emails/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_bounce_email_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"bounce_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/bounce_emails(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_bounce_emails_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"bounce_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /api/campaigns/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_campaign_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/campaign_updates/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_campaign_update_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaign_updates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/campaigns(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_campaigns_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /api/custom_fields/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_custom_field_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/custom_fields(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_custom_fields_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"custom_fields"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_default_mailing_list_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/subscribers/:id(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_default_mailing_list_subscriber_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/subscribers(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_default_mailing_list_subscribers_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscribers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_default_mailing_lists_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /api/subscribers_by_email/:email(.:format)
   * @param {any} email
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_global_subscriber_search_by_email_path: __route({"email":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"subscribers_by_email"],[2,[7,"/"],[2,[3,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/suppressed_addresses_by_email/:email(.:format)
   * @param {any} email
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_global_suppressed_address_search_by_email_path: __route({"email":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"suppressed_addresses_by_email"],[2,[7,"/"],[2,[3,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_mailing_list_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/autoresponders/:id(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_mailing_list_autoresponder_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"autoresponders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/autoresponders(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_mailing_list_autoresponders_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"autoresponders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/bee_custom_rows/:id(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_mailing_list_bee_custom_row_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"bee_custom_rows"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/bee_custom_rows(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_mailing_list_bee_custom_rows_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"bee_custom_rows"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/bee_custom_rows/bee_index(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_mailing_list_bee_custom_rows_bee_index_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"bee_custom_rows"],[2,[7,"/"],[2,[6,"bee_index"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/campaigns/:id(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_mailing_list_campaign_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/campaigns(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_mailing_list_campaigns_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/custom_fields/:id(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_mailing_list_custom_field_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/custom_fields(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_mailing_list_custom_fields_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"custom_fields"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/segments/:id(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_mailing_list_segment_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"segments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/segmentation_criterias/:id(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_mailing_list_segmentation_criteria_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"segmentation_criterias"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/segmentation_criterias(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_mailing_list_segmentation_criterias_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"segmentation_criterias"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/segments(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_mailing_list_segments_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"segments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/subscribers/:id(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_mailing_list_subscriber_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/subscriber_imports/:id(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_mailing_list_subscriber_import_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscriber_imports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/subscriber_imports(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_mailing_list_subscriber_imports_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscriber_imports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/subscribers_by_email/:email(.:format)
   * @param {any} mailing_list_id
   * @param {any} email
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_mailing_list_subscriber_search_by_email_path: __route({"mailing_list_id":{"r":true},"email":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscribers_by_email"],[2,[7,"/"],[2,[3,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/subscribers(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_mailing_list_subscribers_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscribers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/suppressed_addresses_by_email/:email(.:format)
   * @param {any} mailing_list_id
   * @param {any} email
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_mailing_list_suppressed_address_search_by_email_path: __route({"mailing_list_id":{"r":true},"email":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"suppressed_addresses_by_email"],[2,[7,"/"],[2,[3,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/templates/:id(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_mailing_list_template_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/templates(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_mailing_list_templates_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_mailing_lists_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /api/organizations/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_organization_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/organizations/:organization_id/api_keys/:id(.:format)
   * @param {any} organization_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_organization_api_key_path: __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"api_keys"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/organizations/:organization_id/api_keys(.:format)
   * @param {any} organization_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_organization_api_keys_path: __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"api_keys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/organizations/:organization_id/bee_custom_rows/:id(.:format)
   * @param {any} organization_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_organization_bee_custom_row_path: __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"bee_custom_rows"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/organizations/:organization_id/bee_custom_rows(.:format)
   * @param {any} organization_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_organization_bee_custom_rows_path: __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"bee_custom_rows"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/organizations/:organization_id/bee_custom_rows/bee_index(.:format)
   * @param {any} organization_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_organization_bee_custom_rows_bee_index_path: __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"bee_custom_rows"],[2,[7,"/"],[2,[6,"bee_index"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/organizations/:organization_id/subscriber_counts(.:format)
   * @param {any} organization_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_organization_subscriber_counts_path: __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"subscriber_counts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/organizations/:organization_id/subscribers_by_email/:email(.:format)
   * @param {any} organization_id
   * @param {any} email
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_organization_subscriber_search_by_email_path: __route({"organization_id":{"r":true},"email":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"subscribers_by_email"],[2,[7,"/"],[2,[3,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/organizations/:organization_id/suppressed_addresses_by_email/:email(.:format)
   * @param {any} organization_id
   * @param {any} email
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_organization_suppressed_address_search_by_email_path: __route({"organization_id":{"r":true},"email":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"suppressed_addresses_by_email"],[2,[7,"/"],[2,[3,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/organizations/:organization_id/suppressed_addresses/:email(.:format)
   * @param {any} organization_id
   * @param {any} email
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_organization_suppression_search_by_organization_path: __route({"organization_id":{"r":true},"email":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"suppressed_addresses"],[2,[7,"/"],[2,[3,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/organizations/:organization_id/users(.:format)
   * @param {any} organization_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_organization_users_path: __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/organizations(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_organizations_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /api/seed_lists/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_seed_list_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"seed_lists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/seed_lists(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_seed_lists_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"seed_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /api/segments/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_segment_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"segments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/segmentation_criterias/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_segmentation_criteria_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"segmentation_criterias"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/segmentation_criterias(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_segmentation_criterias_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"segmentation_criterias"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /api/segments(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_segments_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"segments"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /api/statistics/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_statistics_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"statistics"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/subscriber_counts(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_subscriber_counts_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"subscriber_counts"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /api/subscriber_imports/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_subscriber_import_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"subscriber_imports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/subscriber_imports(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_subscriber_imports_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"subscriber_imports"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /api/suppression_lists/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_suppression_list_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"suppression_lists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/suppression_lists/:suppression_list_id/suppressed_addresses/:id(.:format)
   * @param {any} suppression_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_suppression_list_suppressed_address_path: __route({"suppression_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"suppression_lists"],[2,[7,"/"],[2,[3,"suppression_list_id"],[2,[7,"/"],[2,[6,"suppressed_addresses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/suppression_lists/:suppression_list_id/suppressed_addresses(.:format)
   * @param {any} suppression_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_suppression_list_suppressed_addresses_path: __route({"suppression_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"suppression_lists"],[2,[7,"/"],[2,[3,"suppression_list_id"],[2,[7,"/"],[2,[6,"suppressed_addresses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/suppression_lists(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_suppression_lists_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"suppression_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /api/suppressed_addresses/:email(.:format)
   * @param {any} email
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_suppression_search_by_organization_path: __route({"email":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"suppressed_addresses"],[2,[7,"/"],[2,[3,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/system_campaigns(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_system_campaigns_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"system_campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /api/templates/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_template_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/templates(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_templates_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"templates"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /api/url_domains/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_url_domain_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"url_domains"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/url_domains(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_url_domains_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"url_domains"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /api/users/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_user_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/users(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_users_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /api/v1/mailing_lists/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v1_mailing_list_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v1/mailing_lists/:mailing_list_id/subscribers/:id(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v1_mailing_list_subscriber_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v1/mailing_lists/:mailing_list_id/subscribers(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v1_mailing_list_subscribers_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscribers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v1/mailing_lists(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v1_mailing_lists_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"mailing_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/api_keys/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_api_key_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"api_keys"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/api_keys(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_api_keys_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"api_keys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/bounce_emails/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_bounce_email_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"bounce_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/bounce_emails(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_bounce_emails_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"bounce_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/campaigns/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_campaign_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/campaign_updates/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_campaign_update_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"campaign_updates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/campaigns(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_campaigns_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/custom_fields/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_custom_field_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/custom_fields(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_custom_fields_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"custom_fields"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/subscribers_by_email/:email(.:format)
   * @param {any} email
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_global_subscriber_search_by_email_path: __route({"email":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"subscribers_by_email"],[2,[7,"/"],[2,[3,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/suppressed_addresses_by_email/:email(.:format)
   * @param {any} email
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_global_suppressed_address_search_by_email_path: __route({"email":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"suppressed_addresses_by_email"],[2,[7,"/"],[2,[3,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_mailing_list_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/autoresponders/:id(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_mailing_list_autoresponder_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"autoresponders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/autoresponders(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_mailing_list_autoresponders_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"autoresponders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/bee_custom_rows/:id(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_mailing_list_bee_custom_row_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"bee_custom_rows"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/bee_custom_rows(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_mailing_list_bee_custom_rows_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"bee_custom_rows"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/bee_custom_rows/bee_index(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_mailing_list_bee_custom_rows_bee_index_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"bee_custom_rows"],[2,[7,"/"],[2,[6,"bee_index"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/campaigns/:id(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_mailing_list_campaign_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/campaigns(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_mailing_list_campaigns_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/custom_fields/:id(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_mailing_list_custom_field_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/custom_fields(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_mailing_list_custom_fields_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"custom_fields"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/segments/:id(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_mailing_list_segment_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"segments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/segmentation_criterias/:id(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_mailing_list_segmentation_criteria_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"segmentation_criterias"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/segmentation_criterias(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_mailing_list_segmentation_criterias_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"segmentation_criterias"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/segments(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_mailing_list_segments_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"segments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/subscribers/:id(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_mailing_list_subscriber_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/subscriber_imports/:id(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_mailing_list_subscriber_import_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscriber_imports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/subscriber_imports(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_mailing_list_subscriber_imports_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscriber_imports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/subscribers_by_email/:email(.:format)
   * @param {any} mailing_list_id
   * @param {any} email
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_mailing_list_subscriber_search_by_email_path: __route({"mailing_list_id":{"r":true},"email":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscribers_by_email"],[2,[7,"/"],[2,[3,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/subscribers(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_mailing_list_subscribers_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscribers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/suppressed_addresses_by_email/:email(.:format)
   * @param {any} mailing_list_id
   * @param {any} email
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_mailing_list_suppressed_address_search_by_email_path: __route({"mailing_list_id":{"r":true},"email":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"suppressed_addresses_by_email"],[2,[7,"/"],[2,[3,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/templates/:id(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_mailing_list_template_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/templates(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_mailing_list_templates_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_mailing_lists_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/organizations/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_organization_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/organizations/:organization_id/api_keys/:id(.:format)
   * @param {any} organization_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_organization_api_key_path: __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"api_keys"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/organizations/:organization_id/api_keys(.:format)
   * @param {any} organization_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_organization_api_keys_path: __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"api_keys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/organizations/:organization_id/bee_custom_rows/:id(.:format)
   * @param {any} organization_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_organization_bee_custom_row_path: __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"bee_custom_rows"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/organizations/:organization_id/bee_custom_rows(.:format)
   * @param {any} organization_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_organization_bee_custom_rows_path: __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"bee_custom_rows"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/organizations/:organization_id/bee_custom_rows/bee_index(.:format)
   * @param {any} organization_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_organization_bee_custom_rows_bee_index_path: __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"bee_custom_rows"],[2,[7,"/"],[2,[6,"bee_index"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/organizations/:organization_id/subscriber_counts(.:format)
   * @param {any} organization_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_organization_subscriber_counts_path: __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"subscriber_counts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/organizations/:organization_id/subscribers_by_email/:email(.:format)
   * @param {any} organization_id
   * @param {any} email
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_organization_subscriber_search_by_email_path: __route({"organization_id":{"r":true},"email":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"subscribers_by_email"],[2,[7,"/"],[2,[3,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/organizations/:organization_id/suppressed_addresses_by_email/:email(.:format)
   * @param {any} organization_id
   * @param {any} email
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_organization_suppressed_address_search_by_email_path: __route({"organization_id":{"r":true},"email":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"suppressed_addresses_by_email"],[2,[7,"/"],[2,[3,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/organizations/:organization_id/suppressed_addresses/:email(.:format)
   * @param {any} organization_id
   * @param {any} email
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_organization_suppression_search_by_organization_path: __route({"organization_id":{"r":true},"email":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"suppressed_addresses"],[2,[7,"/"],[2,[3,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/organizations/:organization_id/users(.:format)
   * @param {any} organization_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_organization_users_path: __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/organizations(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_organizations_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/seed_lists/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_seed_list_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"seed_lists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/seed_lists(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_seed_lists_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"seed_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/segments/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_segment_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"segments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/segmentation_criterias/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_segmentation_criteria_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"segmentation_criterias"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/segmentation_criterias(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_segmentation_criterias_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"segmentation_criterias"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/segments(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_segments_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"segments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/statistics/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_statistics_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"statistics"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/subscriber_counts(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_subscriber_counts_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"subscriber_counts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/subscriber_imports/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_subscriber_import_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"subscriber_imports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/subscriber_imports(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_subscriber_imports_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"subscriber_imports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/suppression_lists/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_suppression_list_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"suppression_lists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/suppression_lists/:suppression_list_id/suppressed_addresses/:id(.:format)
   * @param {any} suppression_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_suppression_list_suppressed_address_path: __route({"suppression_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"suppression_lists"],[2,[7,"/"],[2,[3,"suppression_list_id"],[2,[7,"/"],[2,[6,"suppressed_addresses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/suppression_lists/:suppression_list_id/suppressed_addresses(.:format)
   * @param {any} suppression_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_suppression_list_suppressed_addresses_path: __route({"suppression_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"suppression_lists"],[2,[7,"/"],[2,[3,"suppression_list_id"],[2,[7,"/"],[2,[6,"suppressed_addresses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/suppression_lists(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_suppression_lists_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"suppression_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/suppressed_addresses/:email(.:format)
   * @param {any} email
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_suppression_search_by_organization_path: __route({"email":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"suppressed_addresses"],[2,[7,"/"],[2,[3,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/system_campaigns(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_system_campaigns_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"system_campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/templates/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_template_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/templates(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_templates_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/url_domains/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_url_domain_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"url_domains"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/url_domains(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_url_domains_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"url_domains"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/users/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_user_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/users(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_users_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/virtual_mtas/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_virtual_mta_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"virtual_mtas"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/virtual_mtas(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v2_virtual_mtas_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"virtual_mtas"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/virtual_mtas/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_virtual_mta_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"virtual_mtas"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/virtual_mtas(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_virtual_mtas_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"virtual_mtas"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /attachments/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  attachment_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"attachments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /attachments(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  attachments_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"attachments"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /autoresponders/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  autoresponder_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"autoresponders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /autoresponders/:autoresponder_id/autoresponder_images/:id(.:format)
   * @param {any} autoresponder_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  autoresponder_autoresponder_image_path: __route({"autoresponder_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"autoresponders"],[2,[7,"/"],[2,[3,"autoresponder_id"],[2,[7,"/"],[2,[6,"autoresponder_images"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /autoresponders/:autoresponder_id/autoresponder_images(.:format)
   * @param {any} autoresponder_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  autoresponder_autoresponder_images_path: __route({"autoresponder_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"autoresponders"],[2,[7,"/"],[2,[3,"autoresponder_id"],[2,[7,"/"],[2,[6,"autoresponder_images"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/contents/:id/autoresponder_content(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  autoresponder_content_api_content_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"contents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"autoresponder_content"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/contents/:id/autoresponder_content(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  autoresponder_content_api_v2_content_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"contents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"autoresponder_content"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /autoresponders/:id/history(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  autoresponder_history_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"autoresponders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /autoresponder_images/:autoresponder_id/:image_name(.:format)
   * @param {any} autoresponder_id
   * @param {any} image_name
   * @param {object | undefined} options
   * @returns {string} route path
   */
  autoresponder_image_path: __route({"autoresponder_id":{"r":true},"image_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"autoresponder_images"],[2,[7,"/"],[2,[3,"autoresponder_id"],[2,[7,"/"],[2,[3,"image_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /autoresponders/:autoresponder_id/preview_emails/:id(.:format)
   * @param {any} autoresponder_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  autoresponder_preview_email_path: __route({"autoresponder_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"autoresponders"],[2,[7,"/"],[2,[3,"autoresponder_id"],[2,[7,"/"],[2,[6,"preview_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /autoresponders/:autoresponder_id/preview_emails(.:format)
   * @param {any} autoresponder_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  autoresponder_preview_emails_path: __route({"autoresponder_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"autoresponders"],[2,[7,"/"],[2,[3,"autoresponder_id"],[2,[7,"/"],[2,[6,"preview_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /statistics/autoresponders(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  autoresponder_statistics_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"statistics"],[2,[7,"/"],[2,[6,"autoresponders"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /autoresponders(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  autoresponders_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"autoresponders"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /bee_callback(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  bee_callback_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"bee_callback"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/bee_custom_rows/bee_index(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  bee_index_api_mailing_list_bee_custom_rows_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"bee_custom_rows"],[2,[7,"/"],[2,[6,"bee_index"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/organizations/:organization_id/bee_custom_rows/bee_index(.:format)
   * @param {any} organization_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  bee_index_api_organization_bee_custom_rows_path: __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"bee_custom_rows"],[2,[7,"/"],[2,[6,"bee_index"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/bee_custom_rows/bee_index(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  bee_index_api_v2_mailing_list_bee_custom_rows_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"bee_custom_rows"],[2,[7,"/"],[2,[6,"bee_index"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/organizations/:organization_id/bee_custom_rows/bee_index(.:format)
   * @param {any} organization_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  bee_index_api_v2_organization_bee_custom_rows_path: __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"bee_custom_rows"],[2,[7,"/"],[2,[6,"bee_index"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /segmentation_criterias/blank_criteria(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  blank_criteria_segmentation_criterias_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"segmentation_criterias"],[2,[7,"/"],[2,[6,"blank_criteria"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/ip_addresses/:ip_address_id/throttles/by_domain/:domain(.:format)
   * @param {any} ip_address_id
   * @param {any} domain
   * @param {object | undefined} options
   * @returns {string} route path
   */
  by_domain_ip_address_throttles_path: __route({"ip_address_id":{"r":true},"domain":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"ip_addresses"],[2,[7,"/"],[2,[3,"ip_address_id"],[2,[7,"/"],[2,[6,"throttles"],[2,[7,"/"],[2,[6,"by_domain"],[2,[7,"/"],[2,[3,"domain"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:id/calculate_recipients(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  calculate_recipients_campaign_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"calculate_recipients"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  campaign_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:campaign_id/audit_log_entries(.:format)
   * @param {any} campaign_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  campaign_audit_log_entries_path: __route({"campaign_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"audit_log_entries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:campaign_id/audit_log_entries/:id(.:format)
   * @param {any} campaign_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  campaign_audit_log_entry_path: __route({"campaign_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"audit_log_entries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:campaign_id/campaign_images/:id(.:format)
   * @param {any} campaign_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  campaign_campaign_image_path: __route({"campaign_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"campaign_images"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:campaign_id/campaign_images(.:format)
   * @param {any} campaign_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  campaign_campaign_images_path: __route({"campaign_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"campaign_images"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:campaign_id/contents/:id(.:format)
   * @param {any} campaign_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  campaign_content_path: __route({"campaign_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"contents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/contents/:id/campaign_content(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  campaign_content_api_content_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"contents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"campaign_content"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/contents/:id/campaign_content(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  campaign_content_api_v2_content_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"contents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"campaign_content"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:campaign_id/content_names/:id(.:format)
   * @param {any} campaign_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  campaign_content_name_path: __route({"campaign_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"content_names"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:campaign_id/custom_dynamic_contents/:id(.:format)
   * @param {any} campaign_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  campaign_custom_dynamic_content_path: __route({"campaign_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"custom_dynamic_contents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:campaign_id/custom_dynamic_contents(.:format)
   * @param {any} campaign_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  campaign_custom_dynamic_contents_path: __route({"campaign_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"custom_dynamic_contents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:campaign_id/custom_dynamic_template(.:format)
   * @param {any} campaign_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  campaign_custom_dynamic_template_path: __route({"campaign_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"custom_dynamic_template"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /special_sending_rules/:special_sending_rule_id/previews/campaign_form_field(.:format)
   * @param {any} special_sending_rule_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  campaign_form_field_special_sending_rule_previews_path: __route({"special_sending_rule_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"special_sending_rules"],[2,[7,"/"],[2,[3,"special_sending_rule_id"],[2,[7,"/"],[2,[6,"previews"],[2,[7,"/"],[2,[6,"campaign_form_field"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:id/history(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  campaign_history_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /campaign_images/:campaign_id/:image_name(.:format)
   * @param {any} campaign_id
   * @param {any} image_name
   * @param {object | undefined} options
   * @returns {string} route path
   */
  campaign_image_path: __route({"campaign_id":{"r":true},"image_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaign_images"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[3,"image_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:campaign_id/preview_emails/:id(.:format)
   * @param {any} campaign_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  campaign_preview_email_path: __route({"campaign_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"preview_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:campaign_id/preview_emails(.:format)
   * @param {any} campaign_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  campaign_preview_emails_path: __route({"campaign_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"preview_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /statistics(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  campaign_statistics_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:id/campaign_statistics(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  campaign_statistics_api_mailing_list_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"campaign_statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:id/campaign_statistics(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  campaign_statistics_api_v2_mailing_list_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"campaign_statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  campaigns_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /api/subscriber_imports/:id/cancel(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  cancel_api_subscriber_import_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"subscriber_imports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/subscriber_imports/:id/cancel(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  cancel_api_v2_subscriber_import_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"subscriber_imports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:id/cancel(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  cancel_campaign_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /subscriber_imports/:id/cancel(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  cancel_subscriber_import_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscriber_imports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /suppressed_address_imports/:id/cancel(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  cancel_suppressed_address_import_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"suppressed_address_imports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:id/cannot_schedule(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  cannot_schedule_campaign_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cannot_schedule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/check_dns/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  check_dn_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"check_dns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/autoresponders/:id/clear_queue(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  clear_queue_api_mailing_list_autoresponder_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"autoresponders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clear_queue"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/autoresponders/:id/clear_queue(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  clear_queue_api_v2_mailing_list_autoresponder_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"autoresponders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clear_queue"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/autoresponders/:id/clear_queue(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  clear_queue_mailing_list_autoresponder_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"autoresponders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clear_queue"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /click(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  click_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"click"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /statistics/:id/compare_autowinner_snapshots(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  compare_autowinner_snapshots_statistic_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"statistics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"compare_autowinner_snapshots"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /statistics/:id/compare(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  compare_statistic_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"statistics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"compare"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/home/configuration(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  configuration_eui_home_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"home"],[2,[7,"/"],[2,[6,"configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:id/confirm_send(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  confirm_send_campaign_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm_send"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:id/content_sources(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  content_sources_api_mailing_list_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"content_sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:id/content_sources(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  content_sources_api_v2_mailing_list_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"content_sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /tools/convert_html_to_text(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  convert_html_to_text_tools_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"convert_html_to_text"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /eui/dkim_keys/:id/copy(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  copy_eui_dkim_key_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"dkim_keys"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"copy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /bee-fs/:bee_path(.:format)
   * @param {any} bee_path
   * @param {object | undefined} options
   * @returns {string} route path
   */
  create_image_or_directory_path: __route({"bee_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bee-fs"],[2,[7,"/"],[2,[3,"bee_path"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /api/suppression_lists/:suppression_list_id/suppressed_addresses/create_multiple(.:format)
   * @param {any} suppression_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  create_multiple_api_suppression_list_suppressed_addresses_path: __route({"suppression_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"suppression_lists"],[2,[7,"/"],[2,[3,"suppression_list_id"],[2,[7,"/"],[2,[6,"suppressed_addresses"],[2,[7,"/"],[2,[6,"create_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/suppression_lists/:suppression_list_id/suppressed_addresses/create_multiple(.:format)
   * @param {any} suppression_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  create_multiple_api_v2_suppression_list_suppressed_addresses_path: __route({"suppression_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"suppression_lists"],[2,[7,"/"],[2,[3,"suppression_list_id"],[2,[7,"/"],[2,[6,"suppressed_addresses"],[2,[7,"/"],[2,[6,"create_multiple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /custom_fields/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  custom_field_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /custom_fields(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  custom_fields_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"custom_fields"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /organizations/:id/daily_campaign_report(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  daily_campaign_report_organization_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"daily_campaign_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/database_connections/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  database_connection_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"database_connections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/database_connections(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  database_connections_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"database_connections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/subscribers/datatable(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  datatable_mailing_list_subscribers_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[6,"datatable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/incoming_email_domains/default_bounce_mailbox(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  default_bounce_mailbox_incoming_email_domains_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"incoming_email_domains"],[2,[7,"/"],[2,[6,"default_bounce_mailbox"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/url_domains/default(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  default_url_domains_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"url_domains"],[2,[7,"/"],[2,[6,"default"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:id/delete_confirmation_code(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  delete_confirmation_code_api_mailing_list_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_confirmation_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/organizations/:id/delete_confirmation_code(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  delete_confirmation_code_api_organization_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_confirmation_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:id/delete_confirmation_code(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  delete_confirmation_code_api_v2_mailing_list_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_confirmation_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/organizations/:id/delete_confirmation_code(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  delete_confirmation_code_api_v2_organization_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_confirmation_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /bee-fs/:bee_path(.:format)
   * @param {any} bee_path
   * @param {object | undefined} options
   * @returns {string} route path
   */
  delete_image_or_directory_path: __route({"bee_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bee-fs"],[2,[7,"/"],[2,[3,"bee_path"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /api/custom_fields/deleted(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  deleted_api_custom_fields_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[6,"deleted"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/custom_fields/deleted(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  deleted_api_mailing_list_custom_fields_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[6,"deleted"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/custom_fields/deleted(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  deleted_api_v2_custom_fields_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[6,"deleted"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/custom_fields/deleted(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  deleted_api_v2_mailing_list_custom_fields_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[6,"deleted"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:id/destroy(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  destroy_campaign_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /custom_fields/:id/destroy(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  destroy_custom_field_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/user_sessions/destroy(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  destroy_eui_user_sessions_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"user_sessions"],[2,[7,"/"],[2,[6,"destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mui/user_sessions/destroy(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  destroy_mui_user_sessions_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"mui"],[2,[7,"/"],[2,[6,"user_sessions"],[2,[7,"/"],[2,[6,"destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /organizations/:id/destroy(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  destroy_organization_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /organizations/:organization_id/api_keys/:id/destroy(.:format)
   * @param {any} organization_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  destroy_organization_api_key_path: __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"api_keys"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /seed_lists/:id/destroy(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  destroy_seed_list_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"seed_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /segmentation_criterias/:id/destroy(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  destroy_segmentation_criteria_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"segmentation_criterias"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /subscriber_imports/:id/destroy(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  destroy_subscriber_import_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscriber_imports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /suppressed_addresses/:id/destroy(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  destroy_suppressed_address_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"suppressed_addresses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /suppressed_address_imports/:id/destroy(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  destroy_suppressed_address_import_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"suppressed_address_imports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /suppression_lists/:id/destroy(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  destroy_suppression_list_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"suppression_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /user_session/destroy(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  destroy_user_session_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"user_session"],[2,[7,"/"],[2,[6,"destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/disk_queue_summary(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  disk_queue_summary_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"disk_queue_summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/dkim_keys/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  dkim_key_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"dkim_keys"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/dkim_keys(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  dkim_keys_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"dkim_keys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /agree_to_terms_and_conditions/download(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  download_agree_to_terms_and_conditions_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"agree_to_terms_and_conditions"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /special_sending_rules/:special_sending_rule_id/previews/:id/download_attachment(.:format)
   * @param {any} special_sending_rule_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  download_attachment_special_sending_rule_preview_path: __route({"special_sending_rule_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"special_sending_rules"],[2,[7,"/"],[2,[3,"special_sending_rule_id"],[2,[7,"/"],[2,[6,"previews"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_attachment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /statistics/:id/download_link_counts(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  download_link_counts_statistic_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"statistics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_link_counts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /organization-images/:image_id(.:format)
   * @param {any} image_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  download_organization_image_path: __route({"image_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organization-images"],[2,[7,"/"],[2,[3,"image_id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:campaign_id/contents/:content_id/preview_download(.:format)
   * @param {any} campaign_id
   * @param {any} content_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  download_ready_image_path: __route({"campaign_id":{"r":true},"content_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"contents"],[2,[7,"/"],[2,[3,"content_id"],[2,[7,"/"],[2,[6,"preview_download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /organizations/:id/download_sends_report(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  download_sends_report_organization_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download_sends_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /system_config/download_sends_report(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  download_sends_report_system_config_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"system_config"],[2,[7,"/"],[2,[6,"download_sends_report"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /subscriber_exports/:id/download(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  download_subscriber_export_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscriber_exports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /subscriber_imports/:id/download(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  download_subscriber_import_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscriber_imports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /suppressed_address_imports/:id/download(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  download_suppressed_address_import_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"suppressed_address_imports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:id/duplicate(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  duplicate_campaign_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:id/duplicate(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  duplicate_mailing_list_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /agree_to_terms_and_conditions/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_agree_to_terms_and_condition_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"agree_to_terms_and_conditions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/alias_domains/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_alias_domain_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"alias_domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/bounce_emails/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_bounce_email_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"bounce_emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/campaigns/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_campaign_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/custom_fields/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_custom_field_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_default_mailing_list_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/subscribers/:id/edit(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_default_mailing_list_subscriber_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_mailing_list_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/autoresponders/:id/edit(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_mailing_list_autoresponder_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"autoresponders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/bee_custom_rows/:id/edit(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_mailing_list_bee_custom_row_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"bee_custom_rows"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/campaigns/:id/edit(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_mailing_list_campaign_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/segments/:id/edit(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_mailing_list_segment_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"segments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/segmentation_criterias/:id/edit(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_mailing_list_segmentation_criteria_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"segmentation_criterias"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/subscribers/:id/edit(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_mailing_list_subscriber_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/subscriber_imports/:id/edit(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_mailing_list_subscriber_import_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscriber_imports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/templates/:id/edit(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_mailing_list_template_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/organizations/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_organization_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/organizations/:organization_id/bee_custom_rows/:id/edit(.:format)
   * @param {any} organization_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_organization_bee_custom_row_path: __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"bee_custom_rows"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/seed_lists/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_seed_list_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"seed_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/segments/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_segment_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"segments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/segmentation_criterias/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_segmentation_criteria_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"segmentation_criterias"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/suppression_lists/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_suppression_list_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"suppression_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/suppression_lists/:suppression_list_id/suppressed_addresses/:id/edit(.:format)
   * @param {any} suppression_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_suppression_list_suppressed_address_path: __route({"suppression_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"suppression_lists"],[2,[7,"/"],[2,[3,"suppression_list_id"],[2,[7,"/"],[2,[6,"suppressed_addresses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/templates/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_template_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/url_domains/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_url_domain_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"url_domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/users/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_user_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v1/mailing_lists/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_v1_mailing_list_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v1/mailing_lists/:mailing_list_id/subscribers/:id/edit(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_v1_mailing_list_subscriber_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/bounce_emails/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_v2_bounce_email_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"bounce_emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/campaigns/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_v2_campaign_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/custom_fields/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_v2_custom_field_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_v2_mailing_list_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/autoresponders/:id/edit(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_v2_mailing_list_autoresponder_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"autoresponders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/bee_custom_rows/:id/edit(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_v2_mailing_list_bee_custom_row_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"bee_custom_rows"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/campaigns/:id/edit(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_v2_mailing_list_campaign_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/segments/:id/edit(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_v2_mailing_list_segment_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"segments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/segmentation_criterias/:id/edit(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_v2_mailing_list_segmentation_criteria_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"segmentation_criterias"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/subscribers/:id/edit(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_v2_mailing_list_subscriber_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/subscriber_imports/:id/edit(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_v2_mailing_list_subscriber_import_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscriber_imports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/templates/:id/edit(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_v2_mailing_list_template_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/organizations/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_v2_organization_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/organizations/:organization_id/bee_custom_rows/:id/edit(.:format)
   * @param {any} organization_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_v2_organization_bee_custom_row_path: __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"bee_custom_rows"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/seed_lists/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_v2_seed_list_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"seed_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/segments/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_v2_segment_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"segments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/segmentation_criterias/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_v2_segmentation_criteria_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"segmentation_criterias"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/suppression_lists/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_v2_suppression_list_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"suppression_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/suppression_lists/:suppression_list_id/suppressed_addresses/:id/edit(.:format)
   * @param {any} suppression_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_v2_suppression_list_suppressed_address_path: __route({"suppression_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"suppression_lists"],[2,[7,"/"],[2,[3,"suppression_list_id"],[2,[7,"/"],[2,[6,"suppressed_addresses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/templates/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_v2_template_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/url_domains/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_v2_url_domain_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"url_domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/users/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_v2_user_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/virtual_mtas/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_v2_virtual_mta_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"virtual_mtas"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/virtual_mtas/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_api_virtual_mta_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"virtual_mtas"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /attachments/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_attachment_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"attachments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /autoresponders/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_autoresponder_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"autoresponders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /autoresponders/:autoresponder_id/autoresponder_images/:id/edit(.:format)
   * @param {any} autoresponder_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_autoresponder_autoresponder_image_path: __route({"autoresponder_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"autoresponders"],[2,[7,"/"],[2,[3,"autoresponder_id"],[2,[7,"/"],[2,[6,"autoresponder_images"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /autoresponders/:autoresponder_id/preview_emails/:id/edit(.:format)
   * @param {any} autoresponder_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_autoresponder_preview_email_path: __route({"autoresponder_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"autoresponders"],[2,[7,"/"],[2,[3,"autoresponder_id"],[2,[7,"/"],[2,[6,"preview_emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /bee_callback/edit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_bee_callback_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"bee_callback"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_campaign_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:campaign_id/audit_log_entries/:id/edit(.:format)
   * @param {any} campaign_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_campaign_audit_log_entry_path: __route({"campaign_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"audit_log_entries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:campaign_id/campaign_images/:id/edit(.:format)
   * @param {any} campaign_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_campaign_campaign_image_path: __route({"campaign_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"campaign_images"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:campaign_id/content_names/:id/edit(.:format)
   * @param {any} campaign_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_campaign_content_name_path: __route({"campaign_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"content_names"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:campaign_id/custom_dynamic_contents/:id/edit(.:format)
   * @param {any} campaign_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_campaign_custom_dynamic_content_path: __route({"campaign_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"custom_dynamic_contents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:campaign_id/custom_dynamic_template/edit(.:format)
   * @param {any} campaign_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_campaign_custom_dynamic_template_path: __route({"campaign_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"custom_dynamic_template"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:campaign_id/preview_emails/:id/edit(.:format)
   * @param {any} campaign_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_campaign_preview_email_path: __route({"campaign_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"preview_emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:id/edit_content(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_content_campaign_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_content"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:id/edit_content_editor(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_content_editor_campaign_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_content_editor"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /custom_fields/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_custom_field_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/database_connections/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_database_connection_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"database_connections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:id/edit_delivery_settings(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_delivery_settings_campaign_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_delivery_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/dkim_keys/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_dkim_key_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"dkim_keys"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /edm_designer_callback/edit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_edm_designer_callback_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"edm_designer_callback"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /eui/archived_messages/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_eui_archived_message_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"archived_messages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/database_connections/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_eui_database_connection_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"database_connections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/dkim_keys/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_eui_dkim_key_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"dkim_keys"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/home/edit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_eui_home_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"home"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/incoming_email_domains/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_eui_incoming_email_domain_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"incoming_email_domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/incoming_email_domains/:incoming_email_domain_id/domain_users/:id/edit(.:format)
   * @param {any} incoming_email_domain_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_eui_incoming_email_domain_domain_user_path: __route({"incoming_email_domain_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"incoming_email_domains"],[2,[7,"/"],[2,[3,"incoming_email_domain_id"],[2,[7,"/"],[2,[6,"domain_users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/link_replacements/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_eui_link_replacement_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"link_replacements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/mail_classes/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_eui_mail_class_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"mail_classes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/routes/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_eui_route_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"routes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/sending_domains/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_eui_sending_domain_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"sending_domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/system_settings/edit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_eui_system_settings_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"system_settings"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/url_domains/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_eui_url_domain_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"url_domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/users/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_eui_user_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/user_sessions/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_eui_user_session_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"user_sessions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/user_settings/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_eui_user_setting_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/entities/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_eui_virtual_mta_entity_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"entities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/ip_addresses/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_eui_virtual_mta_ip_address_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"ip_addresses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/relay_servers/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_eui_virtual_mta_relay_server_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"relay_servers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/routing_rules/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_eui_virtual_mta_routing_rule_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"routing_rules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/smtp_pattern_lists/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_eui_virtual_mta_smtp_pattern_list_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"smtp_pattern_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/throttle_programs/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_eui_virtual_mta_throttle_program_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"throttle_programs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/throttling_records/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_eui_virtual_mta_throttling_record_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"throttling_records"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/throttling_templates/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_eui_virtual_mta_throttling_template_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"throttling_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /subscriber_imports/:id/edit_field_associations(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_field_associations_subscriber_import_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscriber_imports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_field_associations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /front/forms/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_front_form_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"front"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /front/forms/:form_id/modify_subscribers/:id/edit(.:format)
   * @param {any} form_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_front_form_modify_subscriber_path: __route({"form_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"front"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[3,"form_id"],[2,[7,"/"],[2,[6,"modify_subscribers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /front/forms/:form_id/subscriptions/:id/edit(.:format)
   * @param {any} form_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_front_form_subscription_path: __route({"form_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"front"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[3,"form_id"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /subscriber_imports/:id/edit_import_start(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_import_start_subscriber_import_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscriber_imports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_import_start"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/incoming_email_domains/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_incoming_email_domain_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"incoming_email_domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/incoming_email_domains/:incoming_email_domain_id/alias_domains/:id/edit(.:format)
   * @param {any} incoming_email_domain_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_incoming_email_domain_alias_domain_path: __route({"incoming_email_domain_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"incoming_email_domains"],[2,[7,"/"],[2,[3,"incoming_email_domain_id"],[2,[7,"/"],[2,[6,"alias_domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/incoming_email_domains/:incoming_email_domain_id/mailboxes/:id/edit(.:format)
   * @param {any} incoming_email_domain_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_incoming_email_domain_mailbox_path: __route({"incoming_email_domain_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"incoming_email_domains"],[2,[7,"/"],[2,[3,"incoming_email_domain_id"],[2,[7,"/"],[2,[6,"mailboxes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/ip_addresses/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_ip_address_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"ip_addresses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /jobs/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_job_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/link_replacements/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_link_replacement_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"link_replacements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/mail_classes/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_mail_class_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"mail_classes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/mailboxes/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_mailbox_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"mailboxes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_mailing_list_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/autoresponders/:id/edit(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_mailing_list_autoresponder_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"autoresponders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/campaigns/:id/edit(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_mailing_list_campaign_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/custom_fields/:id/edit(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_mailing_list_custom_field_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/segmentation_criterias/:id/edit(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_mailing_list_segmentation_criteria_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"segmentation_criterias"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/subscribers/:id/edit(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_mailing_list_subscriber_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/subscriber_exports/:id/edit(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_mailing_list_subscriber_export_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscriber_exports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/subscriber_imports/:id/edit(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_mailing_list_subscriber_import_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscriber_imports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/subscribers/search/:id/edit(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_mailing_list_subscribers_search_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/subscription_web_forms/:id/edit(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_mailing_list_subscription_web_form_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscription_web_forms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mui/alerts/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_mui_alert_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mui"],[2,[7,"/"],[2,[6,"alerts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mui/sub_accounts/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_mui_sub_account_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mui"],[2,[7,"/"],[2,[6,"sub_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mui/sub_accounts/:sub_account_id/user_roles/:id/edit(.:format)
   * @param {any} sub_account_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_mui_sub_account_user_role_path: __route({"sub_account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mui"],[2,[7,"/"],[2,[6,"sub_accounts"],[2,[7,"/"],[2,[3,"sub_account_id"],[2,[7,"/"],[2,[6,"user_roles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mui/user_roles/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_mui_user_role_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mui"],[2,[7,"/"],[2,[6,"user_roles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mui/user_sessions/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_mui_user_session_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mui"],[2,[7,"/"],[2,[6,"user_sessions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mui/user_settings/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_mui_user_setting_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mui"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:id/edit_name(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_name_campaign_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /organizations/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_organization_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /organizations/:organization_id/api_keys/:id/edit(.:format)
   * @param {any} organization_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_organization_api_key_path: __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"api_keys"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /organizations/:organization_id/custom_fields/:id/edit(.:format)
   * @param {any} organization_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_organization_custom_field_path: __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /organizations/:organization_id/users/:id/edit(.:format)
   * @param {any} organization_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_organization_user_path: __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/receiving_domains/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_receiving_domain_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"receiving_domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/receiving_domains/:receiving_domain_id/mailboxes/:id/edit(.:format)
   * @param {any} receiving_domain_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_receiving_domain_mailbox_path: __route({"receiving_domain_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"receiving_domains"],[2,[7,"/"],[2,[3,"receiving_domain_id"],[2,[7,"/"],[2,[6,"mailboxes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/relay_servers/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_relay_server_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"relay_servers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/routes/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_route_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"routes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/routing_rules/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_routing_rule_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"routing_rules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:id/edit_schedule(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_schedule_campaign_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_schedule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /seed_lists/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_seed_list_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"seed_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /segmentation_criterias/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_segmentation_criteria_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"segmentation_criterias"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:id/edit_segmentation_criteria(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_segmentation_criteria_campaign_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_segmentation_criteria"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/sending_domains/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_sending_domain_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"sending_domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/shared_tracking_domains/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_shared_tracking_domain_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"shared_tracking_domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /special_sending_rules/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_special_sending_rule_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"special_sending_rules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /special_sending_rules/:special_sending_rule_id/previews/:id/edit(.:format)
   * @param {any} special_sending_rule_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_special_sending_rule_preview_path: __route({"special_sending_rule_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"special_sending_rules"],[2,[7,"/"],[2,[3,"special_sending_rule_id"],[2,[7,"/"],[2,[6,"previews"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /subscriber_exports/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_subscriber_export_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscriber_exports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /subscriber_imports/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_subscriber_import_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscriber_imports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /subscription_web_forms/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_subscription_web_form_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscription_web_forms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /sudo/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_sudo_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sudo"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /suppressed_addresses/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_suppressed_address_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"suppressed_addresses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /suppressed_address_imports/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_suppressed_address_import_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"suppressed_address_imports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /suppression_lists/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_suppression_list_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"suppression_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /suppression_lists/:suppression_list_id/suppressed_addresses/:id/edit(.:format)
   * @param {any} suppression_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_suppression_list_suppressed_address_path: __route({"suppression_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"suppression_lists"],[2,[7,"/"],[2,[3,"suppression_list_id"],[2,[7,"/"],[2,[6,"suppressed_addresses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /suppression_lists/:suppression_list_id/suppressed_address_imports/:id/edit(.:format)
   * @param {any} suppression_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_suppression_list_suppressed_address_import_path: __route({"suppression_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"suppression_lists"],[2,[7,"/"],[2,[3,"suppression_list_id"],[2,[7,"/"],[2,[6,"suppressed_address_imports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /system_config/edit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_system_config_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"system_config"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /templates/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_template_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/throttle_programs/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_throttle_program_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"throttle_programs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/throttling_templates/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_throttling_template_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"throttling_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /tools/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_tool_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/url_domains/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_url_domain_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"url_domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /users/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_user_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /user_session/edit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_user_session_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"user_session"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /web_forms/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_web_form_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"web_forms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /web_form_delivery_settings/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_web_form_delivery_setting_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"web_form_delivery_settings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /web_forms/edit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_web_forms_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"web_forms"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /web_forms/modify_subscribers/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_web_forms_modify_subscriber_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"web_forms"],[2,[7,"/"],[2,[6,"modify_subscribers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /web_forms/subscriptions/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_web_forms_subscription_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"web_forms"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /webviews/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_webview_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"webviews"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /edm_designer_callback(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edm_designer_callback_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"edm_designer_callback"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /custom_fields/empty_option(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  empty_option_custom_fields_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[6,"empty_option"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:id/error_details(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  error_details_campaign_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"error_details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/campaigns/:id/estimate_recipients(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  estimate_recipients_api_campaign_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"estimate_recipients"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/campaigns/:id/estimate_recipients(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  estimate_recipients_api_v2_campaign_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"estimate_recipients"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/archived_messages/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_archived_message_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"archived_messages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/archived_messages(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_archived_messages_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"archived_messages"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /eui/auth_php(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_auth_php_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"auth_php"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /eui/bounce_address_library(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_bounce_address_library_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"bounce_address_library"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /eui/database_connections/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_database_connection_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"database_connections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/database_connections(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_database_connections_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"database_connections"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /eui/disk_queue_summary(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_disk_queue_summary_index_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"disk_queue_summary"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /eui/dkim_keys/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_dkim_key_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"dkim_keys"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/dkim_keys(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_dkim_keys_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"dkim_keys"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /eui/dynamic_deliveries(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_dynamic_deliveries_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"dynamic_deliveries"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /eui/dynamic_deliveries/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_dynamic_delivery_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"dynamic_deliveries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/home(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_home_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"home"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /eui/incoming_email_domains/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_incoming_email_domain_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"incoming_email_domains"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/incoming_email_domains/:incoming_email_domain_id/domain_users/:id(.:format)
   * @param {any} incoming_email_domain_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_incoming_email_domain_domain_user_path: __route({"incoming_email_domain_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"incoming_email_domains"],[2,[7,"/"],[2,[3,"incoming_email_domain_id"],[2,[7,"/"],[2,[6,"domain_users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/incoming_email_domains/:incoming_email_domain_id/domain_users(.:format)
   * @param {any} incoming_email_domain_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_incoming_email_domain_domain_users_path: __route({"incoming_email_domain_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"incoming_email_domains"],[2,[7,"/"],[2,[3,"incoming_email_domain_id"],[2,[7,"/"],[2,[6,"domain_users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/incoming_email_domains(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_incoming_email_domains_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"incoming_email_domains"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /eui/link_replacements/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_link_replacement_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"link_replacements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/link_replacements(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_link_replacements_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"link_replacements"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /eui/mail_classes/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_mail_class_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"mail_classes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/mail_classes(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_mail_classes_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"mail_classes"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /eui/print_http_diag(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_print_http_diag_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"print_http_diag"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /eui/receiving_domains/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_receiving_domain_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"receiving_domains"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/receiving_domains(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_receiving_domains_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"receiving_domains"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /eui(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_root_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /eui/routes/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_route_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"routes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/routes(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_routes_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"routes"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /eui/sending_domains/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_sending_domain_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"sending_domains"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/sending_domains(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_sending_domains_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"sending_domains"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /eui/shared_tracking_domains/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_shared_tracking_domain_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"shared_tracking_domains"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/shared_tracking_domains(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_shared_tracking_domains_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"shared_tracking_domains"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /eui/system_settings(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_system_settings_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"system_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /eui/two_factor_authentications(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_two_factor_authentications_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"two_factor_authentications"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /eui/url_domains/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_url_domain_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"url_domains"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/url_domains(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_url_domains_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"url_domains"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /eui/users/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_user_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/user_sessions/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_user_session_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"user_sessions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/user_sessions(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_user_sessions_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"user_sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /eui/user_settings/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_user_setting_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/user_settings(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_user_settings_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"user_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /eui/users(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_users_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/eng_throttles/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_virtual_mta_eng_throttle_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"eng_throttles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/eng_throttles(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_virtual_mta_eng_throttles_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"eng_throttles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/entities(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_virtual_mta_entities_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"entities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/entities/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_virtual_mta_entity_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"entities"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/ip_addresses/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_virtual_mta_ip_address_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"ip_addresses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/ip_addresses(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_virtual_mta_ip_addresses_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"ip_addresses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/library(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_virtual_mta_library_index_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"library"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/paused_domains/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_virtual_mta_paused_domain_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"paused_domains"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/paused_domains(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_virtual_mta_paused_domains_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"paused_domains"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/relay_servers/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_virtual_mta_relay_server_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"relay_servers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/relay_servers(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_virtual_mta_relay_servers_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"relay_servers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/routing_rules/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_virtual_mta_routing_rule_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"routing_rules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/routing_rules(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_virtual_mta_routing_rules_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"routing_rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/smtp_pattern_lists/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_virtual_mta_smtp_pattern_list_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"smtp_pattern_lists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/smtp_pattern_lists(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_virtual_mta_smtp_pattern_lists_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"smtp_pattern_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/throttle_programs/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_virtual_mta_throttle_program_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"throttle_programs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/throttle_programs(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_virtual_mta_throttle_programs_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"throttle_programs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/throttling_records/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_virtual_mta_throttling_record_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"throttling_records"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/throttling_records(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_virtual_mta_throttling_records_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"throttling_records"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/throttling_templates/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_virtual_mta_throttling_template_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"throttling_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/throttling_templates(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  eui_virtual_mta_throttling_templates_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"throttling_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/export_dns(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export_dns_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"export_dns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/ip_addresses/:id/find_throttling_rule(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  find_throttling_rule_eui_virtual_mta_ip_address_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"ip_addresses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"find_throttling_rule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /jobs/finished(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  finished_jobs_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"finished"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /front/modify_subscribers/confirm/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  front_confirm_modify_subscriber_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"front"],[2,[7,"/"],[2,[6,"modify_subscribers"],[2,[7,"/"],[2,[6,"confirm"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /front/subscriptions/confirm/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  front_confirm_subscription_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"front"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"confirm"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /front/forms/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  front_form_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"front"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /front/forms/:form_id/modify_subscribers/:id(.:format)
   * @param {any} form_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  front_form_modify_subscriber_path: __route({"form_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"front"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[3,"form_id"],[2,[7,"/"],[2,[6,"modify_subscribers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /front/forms/:form_id/subscriptions/:id(.:format)
   * @param {any} form_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  front_form_subscription_path: __route({"form_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"front"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[3,"form_id"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /front/forms/:form_id/subscriptions(.:format)
   * @param {any} form_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  front_form_subscriptions_path: __route({"form_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"front"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[3,"form_id"],[2,[7,"/"],[2,[6,"subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /front/forms/:form_id/subscriptions/new(.:format)
   * @param {any} form_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  front_form_subscriptions_new_path: __route({"form_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"front"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[3,"form_id"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /front/forms(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  front_forms_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"front"],[2,[7,"/"],[2,[6,"forms"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /api/campaign_updates/:id/get_content_for_editor_preview(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  get_content_for_editor_preview_api_campaign_update_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaign_updates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"get_content_for_editor_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/campaign_updates/:id/get_content_for_editor_preview(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  get_content_for_editor_preview_api_v2_campaign_update_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"campaign_updates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"get_content_for_editor_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/virtual_mtas/default(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  get_default_virtual_mtas_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"virtual_mtas"],[2,[7,"/"],[2,[6,"default"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /jobs/in_progress(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  in_progress_jobs_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"in_progress"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/incoming_email_domains/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  incoming_email_domain_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"incoming_email_domains"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/incoming_email_domains/:incoming_email_domain_id/alias_domains/:id(.:format)
   * @param {any} incoming_email_domain_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  incoming_email_domain_alias_domain_path: __route({"incoming_email_domain_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"incoming_email_domains"],[2,[7,"/"],[2,[3,"incoming_email_domain_id"],[2,[7,"/"],[2,[6,"alias_domains"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/incoming_email_domains/:incoming_email_domain_id/alias_domains(.:format)
   * @param {any} incoming_email_domain_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  incoming_email_domain_alias_domains_path: __route({"incoming_email_domain_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"incoming_email_domains"],[2,[7,"/"],[2,[3,"incoming_email_domain_id"],[2,[7,"/"],[2,[6,"alias_domains"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/incoming_email_domains/:incoming_email_domain_id/mailboxes/:id(.:format)
   * @param {any} incoming_email_domain_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  incoming_email_domain_mailbox_path: __route({"incoming_email_domain_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"incoming_email_domains"],[2,[7,"/"],[2,[3,"incoming_email_domain_id"],[2,[7,"/"],[2,[6,"mailboxes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/incoming_email_domains/:incoming_email_domain_id/mailboxes(.:format)
   * @param {any} incoming_email_domain_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  incoming_email_domain_mailboxes_path: __route({"incoming_email_domain_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"incoming_email_domains"],[2,[7,"/"],[2,[3,"incoming_email_domain_id"],[2,[7,"/"],[2,[6,"mailboxes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/incoming_email_domains(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  incoming_email_domains_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"incoming_email_domains"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/ip_addresses/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  ip_address_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"ip_addresses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/ip_addresses/:ip_address_id/throttling_rules/:id(.:format)
   * @param {any} ip_address_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  ip_address_ip_address_rule_path: __route({"ip_address_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"ip_addresses"],[2,[7,"/"],[2,[3,"ip_address_id"],[2,[7,"/"],[2,[6,"throttling_rules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/ip_addresses/:ip_address_id/throttling_rules(.:format)
   * @param {any} ip_address_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  ip_address_ip_address_rules_path: __route({"ip_address_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"ip_addresses"],[2,[7,"/"],[2,[3,"ip_address_id"],[2,[7,"/"],[2,[6,"throttling_rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/ip_addresses/:ip_address_id/throttles(.:format)
   * @param {any} ip_address_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  ip_address_throttles_path: __route({"ip_address_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"ip_addresses"],[2,[7,"/"],[2,[3,"ip_address_id"],[2,[7,"/"],[2,[6,"throttles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/ip_addresses/:ip_address_id/used_by(.:format)
   * @param {any} ip_address_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  ip_address_used_by_index_path: __route({"ip_address_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"ip_addresses"],[2,[7,"/"],[2,[3,"ip_address_id"],[2,[7,"/"],[2,[6,"used_by"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/ip_addresses(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  ip_addresses_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"ip_addresses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /jobs/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  job_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /jobs(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  jobs_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"jobs"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/link_replacements/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  link_replacement_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"link_replacements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/link_replacements(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  link_replacements_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"link_replacements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/campaigns/:id/link_stats(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  link_stats_api_campaign_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"link_stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/campaigns/:id/link_stats(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  link_stats_api_v2_campaign_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"link_stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /bee-fs(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  list_image_directories_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"bee-fs"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /tools/load_url_content(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  load_url_content_tools_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"load_url_content"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/mail_classes/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mail_class_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"mail_classes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/mail_classes(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mail_classes_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"mail_classes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/mailboxes/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mailbox_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"mailboxes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/mailboxes(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mailboxes_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"mailboxes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mailing_list_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/autoresponders/:id(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mailing_list_autoresponder_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"autoresponders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/autoresponders(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mailing_list_autoresponders_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"autoresponders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/campaigns/:id(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mailing_list_campaign_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/campaigns(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mailing_list_campaigns_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/custom_fields/:id(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mailing_list_custom_field_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/custom_fields(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mailing_list_custom_fields_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"custom_fields"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/segmentation_criterias/:id(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mailing_list_segmentation_criteria_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"segmentation_criterias"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/segmentation_criterias(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mailing_list_segmentation_criterias_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"segmentation_criterias"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/subscribers/:id(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mailing_list_subscriber_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/subscriber_exports/:id(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mailing_list_subscriber_export_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscriber_exports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/subscriber_exports(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mailing_list_subscriber_exports_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscriber_exports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/subscriber_imports/:id(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mailing_list_subscriber_import_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscriber_imports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/subscriber_imports(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mailing_list_subscriber_imports_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscriber_imports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/subscribers(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mailing_list_subscribers_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscribers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/subscribers/search/:id(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mailing_list_subscribers_search_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/subscribers/search(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mailing_list_subscribers_search_index_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/subscription_web_forms/:id(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mailing_list_subscription_web_form_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscription_web_forms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/subscription_web_forms(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mailing_list_subscription_web_forms_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscription_web_forms"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/web_forms/modify_subscribers(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mailing_list_web_forms_modify_subscribers_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"web_forms"],[2,[7,"/"],[2,[6,"modify_subscribers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mailing_lists_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /api/organizations/:id/messages_sent/daily(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  messages_sent_daily_api_organization_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"messages_sent"],[2,[7,"/"],[2,[6,"daily"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/organizations/:id/messages_sent/daily(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  messages_sent_daily_api_v2_organization_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"messages_sent"],[2,[7,"/"],[2,[6,"daily"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/organizations/:id/messages_sent/monthly(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  messages_sent_monthly_api_organization_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"messages_sent"],[2,[7,"/"],[2,[6,"monthly"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/organizations/:id/messages_sent/monthly(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  messages_sent_monthly_api_v2_organization_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"messages_sent"],[2,[7,"/"],[2,[6,"monthly"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /organizations/:id/monthly_campaign_report(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  monthly_campaign_report_organization_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"monthly_campaign_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mui/*path(.:format)
   * @param {any} path
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mui_path: __route({"path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mui"],[2,[7,"/"],[2,[5,[3,"path"]],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mui/alerts/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mui_alert_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mui"],[2,[7,"/"],[2,[6,"alerts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mui/alerts(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mui_alerts_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"mui"],[2,[7,"/"],[2,[6,"alerts"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mui/campaigns/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mui_campaign_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mui"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mui/campaigns(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mui_campaigns_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"mui"],[2,[7,"/"],[2,[6,"campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mui/message_download/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mui_message_download_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mui"],[2,[7,"/"],[2,[6,"message_download"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mui/password_resets(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mui_password_resets_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"mui"],[2,[7,"/"],[2,[6,"password_resets"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mui/role_selection/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mui_role_selection_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mui"],[2,[7,"/"],[2,[6,"role_selection"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mui(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mui_root_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"mui"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /mui/seed_lists(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mui_seed_lists_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"mui"],[2,[7,"/"],[2,[6,"seed_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mui/sub_accounts/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mui_sub_account_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mui"],[2,[7,"/"],[2,[6,"sub_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mui/sub_accounts/:sub_account_id/user_roles/:id(.:format)
   * @param {any} sub_account_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mui_sub_account_user_role_path: __route({"sub_account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mui"],[2,[7,"/"],[2,[6,"sub_accounts"],[2,[7,"/"],[2,[3,"sub_account_id"],[2,[7,"/"],[2,[6,"user_roles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mui/sub_accounts/:sub_account_id/user_roles(.:format)
   * @param {any} sub_account_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mui_sub_account_user_roles_path: __route({"sub_account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mui"],[2,[7,"/"],[2,[6,"sub_accounts"],[2,[7,"/"],[2,[3,"sub_account_id"],[2,[7,"/"],[2,[6,"user_roles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mui/sub_accounts(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mui_sub_accounts_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"mui"],[2,[7,"/"],[2,[6,"sub_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mui/user_activations(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mui_user_activations_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"mui"],[2,[7,"/"],[2,[6,"user_activations"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mui/user_roles/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mui_user_role_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mui"],[2,[7,"/"],[2,[6,"user_roles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mui/user_roles(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mui_user_roles_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"mui"],[2,[7,"/"],[2,[6,"user_roles"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mui/user_sessions/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mui_user_session_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mui"],[2,[7,"/"],[2,[6,"user_sessions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mui/user_sessions(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mui_user_sessions_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"mui"],[2,[7,"/"],[2,[6,"user_sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mui/user_settings/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mui_user_setting_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mui"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mui/user_settings(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mui_user_settings_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"mui"],[2,[7,"/"],[2,[6,"user_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /agree_to_terms_and_conditions/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_agree_to_terms_and_condition_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"agree_to_terms_and_conditions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/alias_domains/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_alias_domain_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"alias_domains"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/incoming_email_domains/new_alias(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_alias_eui_incoming_email_domains_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"incoming_email_domains"],[2,[7,"/"],[2,[6,"new_alias"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/bounce_emails/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_bounce_email_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"bounce_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/campaigns/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_campaign_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/custom_fields/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_custom_field_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_default_mailing_list_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/subscribers/new(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_default_mailing_list_subscriber_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_mailing_list_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/autoresponders/new(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_mailing_list_autoresponder_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"autoresponders"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/bee_custom_rows/new(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_mailing_list_bee_custom_row_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"bee_custom_rows"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/campaigns/new(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_mailing_list_campaign_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/segments/new(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_mailing_list_segment_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"segments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/segmentation_criterias/new(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_mailing_list_segmentation_criteria_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"segmentation_criterias"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/subscribers/new(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_mailing_list_subscriber_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/subscriber_imports/new(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_mailing_list_subscriber_import_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscriber_imports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/templates/new(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_mailing_list_template_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/organizations/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_organization_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/organizations/:organization_id/bee_custom_rows/new(.:format)
   * @param {any} organization_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_organization_bee_custom_row_path: __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"bee_custom_rows"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/seed_lists/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_seed_list_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"seed_lists"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/segments/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_segment_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"segments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/segmentation_criterias/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_segmentation_criteria_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"segmentation_criterias"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/suppression_lists/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_suppression_list_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"suppression_lists"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/suppression_lists/:suppression_list_id/suppressed_addresses/new(.:format)
   * @param {any} suppression_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_suppression_list_suppressed_address_path: __route({"suppression_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"suppression_lists"],[2,[7,"/"],[2,[3,"suppression_list_id"],[2,[7,"/"],[2,[6,"suppressed_addresses"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/templates/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_template_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/url_domains/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_url_domain_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"url_domains"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/users/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_user_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v1/mailing_lists/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_v1_mailing_list_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v1/mailing_lists/:mailing_list_id/subscribers/new(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_v1_mailing_list_subscriber_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/bounce_emails/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_v2_bounce_email_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"bounce_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/campaigns/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_v2_campaign_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/custom_fields/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_v2_custom_field_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_v2_mailing_list_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/autoresponders/new(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_v2_mailing_list_autoresponder_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"autoresponders"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/bee_custom_rows/new(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_v2_mailing_list_bee_custom_row_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"bee_custom_rows"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/campaigns/new(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_v2_mailing_list_campaign_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/segments/new(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_v2_mailing_list_segment_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"segments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/segmentation_criterias/new(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_v2_mailing_list_segmentation_criteria_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"segmentation_criterias"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/subscribers/new(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_v2_mailing_list_subscriber_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/subscriber_imports/new(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_v2_mailing_list_subscriber_import_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscriber_imports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/templates/new(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_v2_mailing_list_template_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/organizations/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_v2_organization_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/organizations/:organization_id/bee_custom_rows/new(.:format)
   * @param {any} organization_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_v2_organization_bee_custom_row_path: __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"bee_custom_rows"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/seed_lists/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_v2_seed_list_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"seed_lists"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/segments/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_v2_segment_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"segments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/segmentation_criterias/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_v2_segmentation_criteria_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"segmentation_criterias"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/suppression_lists/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_v2_suppression_list_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"suppression_lists"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/suppression_lists/:suppression_list_id/suppressed_addresses/new(.:format)
   * @param {any} suppression_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_v2_suppression_list_suppressed_address_path: __route({"suppression_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"suppression_lists"],[2,[7,"/"],[2,[3,"suppression_list_id"],[2,[7,"/"],[2,[6,"suppressed_addresses"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/templates/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_v2_template_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/url_domains/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_v2_url_domain_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"url_domains"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/users/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_v2_user_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/virtual_mtas/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_v2_virtual_mta_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"virtual_mtas"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/virtual_mtas/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_api_virtual_mta_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"virtual_mtas"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /attachments/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_attachment_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"attachments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /autoresponders/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_autoresponder_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"autoresponders"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /autoresponders/:autoresponder_id/autoresponder_images/new(.:format)
   * @param {any} autoresponder_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_autoresponder_autoresponder_image_path: __route({"autoresponder_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"autoresponders"],[2,[7,"/"],[2,[3,"autoresponder_id"],[2,[7,"/"],[2,[6,"autoresponder_images"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /autoresponders/:autoresponder_id/preview_emails/new(.:format)
   * @param {any} autoresponder_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_autoresponder_preview_email_path: __route({"autoresponder_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"autoresponders"],[2,[7,"/"],[2,[3,"autoresponder_id"],[2,[7,"/"],[2,[6,"preview_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /bee_callback/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_bee_callback_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"bee_callback"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_campaign_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:campaign_id/audit_log_entries/new(.:format)
   * @param {any} campaign_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_campaign_audit_log_entry_path: __route({"campaign_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"audit_log_entries"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:campaign_id/campaign_images/new(.:format)
   * @param {any} campaign_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_campaign_campaign_image_path: __route({"campaign_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"campaign_images"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:campaign_id/custom_dynamic_contents/new(.:format)
   * @param {any} campaign_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_campaign_custom_dynamic_content_path: __route({"campaign_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"custom_dynamic_contents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:campaign_id/custom_dynamic_template/new(.:format)
   * @param {any} campaign_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_campaign_custom_dynamic_template_path: __route({"campaign_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"custom_dynamic_template"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:campaign_id/preview_emails/new(.:format)
   * @param {any} campaign_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_campaign_preview_email_path: __route({"campaign_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"preview_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /custom_fields/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_custom_field_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/database_connections/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_database_connection_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"database_connections"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/dkim_keys/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_dkim_key_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"dkim_keys"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /edm_designer_callback/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_edm_designer_callback_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"edm_designer_callback"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /eui/archived_messages/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_eui_archived_message_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"archived_messages"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/database_connections/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_eui_database_connection_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"database_connections"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/dkim_keys/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_eui_dkim_key_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"dkim_keys"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/home/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_eui_home_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"home"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/incoming_email_domains/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_eui_incoming_email_domain_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"incoming_email_domains"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/incoming_email_domains/:incoming_email_domain_id/domain_users/new(.:format)
   * @param {any} incoming_email_domain_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_eui_incoming_email_domain_domain_user_path: __route({"incoming_email_domain_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"incoming_email_domains"],[2,[7,"/"],[2,[3,"incoming_email_domain_id"],[2,[7,"/"],[2,[6,"domain_users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/link_replacements/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_eui_link_replacement_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"link_replacements"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/mail_classes/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_eui_mail_class_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"mail_classes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/receiving_domains/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_eui_receiving_domain_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"receiving_domains"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/routes/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_eui_route_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"routes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/sending_domains/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_eui_sending_domain_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"sending_domains"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/shared_tracking_domains/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_eui_shared_tracking_domain_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"shared_tracking_domains"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/system_settings/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_eui_system_settings_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"system_settings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/two_factor_authentications/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_eui_two_factor_authentication_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"two_factor_authentications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/url_domains/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_eui_url_domain_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"url_domains"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/users/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_eui_user_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/user_sessions/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_eui_user_session_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"user_sessions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/user_settings/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_eui_user_setting_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/entities/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_eui_virtual_mta_entity_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"entities"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/ip_addresses/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_eui_virtual_mta_ip_address_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"ip_addresses"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/relay_servers/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_eui_virtual_mta_relay_server_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"relay_servers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/routing_rules/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_eui_virtual_mta_routing_rule_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"routing_rules"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/smtp_pattern_lists/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_eui_virtual_mta_smtp_pattern_list_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"smtp_pattern_lists"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/throttle_programs/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_eui_virtual_mta_throttle_program_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"throttle_programs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/throttling_records/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_eui_virtual_mta_throttling_record_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"throttling_records"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/throttling_templates/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_eui_virtual_mta_throttling_template_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"throttling_templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /front/forms/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_front_form_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"front"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /front/forms/:form_id/subscriptions/new(.:format)
   * @param {any} form_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_front_form_subscription_path: __route({"form_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"front"],[2,[7,"/"],[2,[6,"forms"],[2,[7,"/"],[2,[3,"form_id"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/incoming_email_domains/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_incoming_email_domain_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"incoming_email_domains"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/incoming_email_domains/:incoming_email_domain_id/alias_domains/new(.:format)
   * @param {any} incoming_email_domain_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_incoming_email_domain_alias_domain_path: __route({"incoming_email_domain_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"incoming_email_domains"],[2,[7,"/"],[2,[3,"incoming_email_domain_id"],[2,[7,"/"],[2,[6,"alias_domains"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/incoming_email_domains/:incoming_email_domain_id/mailboxes/new(.:format)
   * @param {any} incoming_email_domain_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_incoming_email_domain_mailbox_path: __route({"incoming_email_domain_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"incoming_email_domains"],[2,[7,"/"],[2,[3,"incoming_email_domain_id"],[2,[7,"/"],[2,[6,"mailboxes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/ip_addresses/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_ip_address_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"ip_addresses"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /jobs/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_job_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/link_replacements/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_link_replacement_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"link_replacements"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/mail_classes/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_mail_class_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"mail_classes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/mailboxes/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_mailbox_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"mailboxes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_mailing_list_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/autoresponders/new(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_mailing_list_autoresponder_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"autoresponders"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/campaigns/new(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_mailing_list_campaign_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/custom_fields/new(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_mailing_list_custom_field_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/segmentation_criterias/new(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_mailing_list_segmentation_criteria_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"segmentation_criterias"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/subscribers/new(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_mailing_list_subscriber_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/subscriber_exports/new(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_mailing_list_subscriber_export_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscriber_exports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/subscriber_imports/new(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_mailing_list_subscriber_import_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscriber_imports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/subscribers/search/new(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_mailing_list_subscribers_search_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/subscription_web_forms/new(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_mailing_list_subscription_web_form_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscription_web_forms"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/web_forms/modify_subscribers/new(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_mailing_list_web_forms_modify_subscriber_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"web_forms"],[2,[7,"/"],[2,[6,"modify_subscribers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mui/alerts/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_mui_alert_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"mui"],[2,[7,"/"],[2,[6,"alerts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mui/sub_accounts/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_mui_sub_account_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"mui"],[2,[7,"/"],[2,[6,"sub_accounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mui/sub_accounts/:sub_account_id/user_roles/new(.:format)
   * @param {any} sub_account_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_mui_sub_account_user_role_path: __route({"sub_account_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mui"],[2,[7,"/"],[2,[6,"sub_accounts"],[2,[7,"/"],[2,[3,"sub_account_id"],[2,[7,"/"],[2,[6,"user_roles"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mui/user_roles/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_mui_user_role_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"mui"],[2,[7,"/"],[2,[6,"user_roles"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mui/user_sessions/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_mui_user_session_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"mui"],[2,[7,"/"],[2,[6,"user_sessions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mui/user_settings/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_mui_user_setting_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"mui"],[2,[7,"/"],[2,[6,"user_settings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /organizations/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_organization_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /organizations/:organization_id/api_keys/new(.:format)
   * @param {any} organization_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_organization_api_key_path: __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"api_keys"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /organizations/:organization_id/custom_fields/new(.:format)
   * @param {any} organization_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_organization_custom_field_path: __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /organizations/:organization_id/users/new(.:format)
   * @param {any} organization_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_organization_user_path: __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/conductor/action_mailbox/inbound_emails/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_rails_conductor_inbound_email_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/conductor/action_mailbox/inbound_emails/sources/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_rails_conductor_inbound_email_source_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/receiving_domains/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_receiving_domain_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"receiving_domains"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/receiving_domains/:receiving_domain_id/mailboxes/new(.:format)
   * @param {any} receiving_domain_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_receiving_domain_mailbox_path: __route({"receiving_domain_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"receiving_domains"],[2,[7,"/"],[2,[3,"receiving_domain_id"],[2,[7,"/"],[2,[6,"mailboxes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/relay_servers/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_relay_server_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"relay_servers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/routes/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_route_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"routes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/routing_rules/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_routing_rule_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"routing_rules"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /seed_lists/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_seed_list_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"seed_lists"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /segmentation_criterias/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_segmentation_criteria_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"segmentation_criterias"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/sending_domains/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_sending_domain_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"sending_domains"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/shared_tracking_domains/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_shared_tracking_domain_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"shared_tracking_domains"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /special_sending_rules/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_special_sending_rule_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"special_sending_rules"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /special_sending_rules/:special_sending_rule_id/previews/new(.:format)
   * @param {any} special_sending_rule_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_special_sending_rule_preview_path: __route({"special_sending_rule_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"special_sending_rules"],[2,[7,"/"],[2,[3,"special_sending_rule_id"],[2,[7,"/"],[2,[6,"previews"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /subscriber_exports/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_subscriber_export_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"subscriber_exports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /subscriber_imports/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_subscriber_import_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"subscriber_imports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /subscription_web_forms/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_subscription_web_form_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"subscription_web_forms"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /sudo/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_sudo_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"sudo"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /suppressed_addresses/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_suppressed_address_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"suppressed_addresses"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /suppressed_address_imports/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_suppressed_address_import_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"suppressed_address_imports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /suppression_lists/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_suppression_list_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"suppression_lists"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /suppression_lists/:suppression_list_id/suppressed_addresses/new(.:format)
   * @param {any} suppression_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_suppression_list_suppressed_address_path: __route({"suppression_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"suppression_lists"],[2,[7,"/"],[2,[3,"suppression_list_id"],[2,[7,"/"],[2,[6,"suppressed_addresses"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /suppression_lists/:suppression_list_id/suppressed_address_imports/new(.:format)
   * @param {any} suppression_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_suppression_list_suppressed_address_import_path: __route({"suppression_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"suppression_lists"],[2,[7,"/"],[2,[3,"suppression_list_id"],[2,[7,"/"],[2,[6,"suppressed_address_imports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /system_config/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_system_config_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"system_config"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /templates/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_template_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/throttle_programs/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_throttle_program_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"throttle_programs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/throttling_templates/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_throttling_template_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"throttling_templates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /tools/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_tool_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /two_factor_authentications/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_two_factor_authentication_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"two_factor_authentications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/url_domains/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_url_domain_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"url_domains"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /users/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_user_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /user_session/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_user_session_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"user_session"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /web_forms/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_web_form_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"web_forms"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /web_form_delivery_settings/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_web_form_delivery_setting_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"web_form_delivery_settings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /web_forms/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_web_forms_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"web_forms"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /web_forms/subscriptions/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_web_forms_subscription_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"web_forms"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /webviews/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_webview_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"webviews"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /open/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  open_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"open"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /organizations/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  organization_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /organizations/:organization_id/api_keys/:id(.:format)
   * @param {any} organization_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  organization_api_key_path: __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"api_keys"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /organizations/:organization_id/api_keys(.:format)
   * @param {any} organization_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  organization_api_keys_path: __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"api_keys"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /organizations/:organization_id/custom_fields/:id(.:format)
   * @param {any} organization_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  organization_custom_field_path: __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /organizations/:organization_id/custom_fields(.:format)
   * @param {any} organization_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  organization_custom_fields_path: __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"custom_fields"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /organizations/:organization_id/mailing_lists(.:format)
   * @param {any} organization_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  organization_mailing_lists_path: __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"mailing_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /organizations/:organization_id/users/:id(.:format)
   * @param {any} organization_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  organization_user_path: __route({"organization_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /organizations/:organization_id/users(.:format)
   * @param {any} organization_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  organization_users_path: __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /organizations(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  organizations_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /eui/user_sessions/two_factor(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  otp_eui_user_sessions_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"user_sessions"],[2,[7,"/"],[2,[6,"two_factor"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /user_session/two_factor(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  otp_user_session_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"user_session"],[2,[7,"/"],[2,[6,"two_factor"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /tools/parse_time(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  parse_time_tools_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"parse_time"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /api/campaigns/:id/pause(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  pause_api_campaign_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/autoresponders/:id/pause(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  pause_api_mailing_list_autoresponder_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"autoresponders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/campaigns/:id/pause(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  pause_api_mailing_list_campaign_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/subscriber_imports/:id/pause(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  pause_api_subscriber_import_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"subscriber_imports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/campaigns/:id/pause(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  pause_api_v2_campaign_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/autoresponders/:id/pause(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  pause_api_v2_mailing_list_autoresponder_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"autoresponders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/campaigns/:id/pause(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  pause_api_v2_mailing_list_campaign_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/subscriber_imports/:id/pause(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  pause_api_v2_subscriber_import_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"subscriber_imports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/autoresponders/:id/pause(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  pause_mailing_list_autoresponder_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"autoresponders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:id/pause_or_resume(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  pause_or_resume_campaign_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pause_or_resume"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /subscriber_exports/:id/pause_or_resume(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  pause_or_resume_subscriber_export_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscriber_exports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pause_or_resume"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /subscriber_imports/:id/pause_or_resume(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  pause_or_resume_subscriber_import_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscriber_imports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pause_or_resume"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /suppressed_address_imports/:id/pause_or_resume(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  pause_or_resume_suppressed_address_import_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"suppressed_address_imports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pause_or_resume"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/paused_domains(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  paused_domains_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"paused_domains"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:campaign_id/contents/:content_id/preview_render(.:format)
   * @param {any} campaign_id
   * @param {any} content_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  poll_for_render_path: __route({"campaign_id":{"r":true},"content_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"contents"],[2,[7,"/"],[2,[3,"content_id"],[2,[7,"/"],[2,[6,"preview_render"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/segmentation_criterias/:id/preview_results(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  preview_results_mailing_list_segmentation_criteria_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"segmentation_criterias"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview_results"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/segmentation_criterias/preview_results(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  preview_results_mailing_list_segmentation_criterias_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"segmentation_criterias"],[2,[7,"/"],[2,[6,"preview_results"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/custom_fields/promote(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  promote_api_custom_fields_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[6,"promote"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/custom_fields/promote(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  promote_api_v2_custom_fields_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[6,"promote"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /organizations/:organization_id/custom_fields/promote(.:format)
   * @param {any} organization_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  promote_organization_custom_fields_path: __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"custom_fields"],[2,[7,"/"],[2,[6,"promote"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
   * @param {any} signed_blob_id
   * @param {any} variation_key
   * @param {any} filename
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_blob_representation_path: __route({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
   * @param {any} signed_blob_id
   * @param {any} variation_key
   * @param {any} filename
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_blob_representation_proxy_path: __route({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/conductor/action_mailbox/inbound_emails/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_conductor_inbound_email_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/conductor/action_mailbox/:inbound_email_id/incinerate(.:format)
   * @param {any} inbound_email_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_conductor_inbound_email_incinerate_path: __route({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"incinerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format)
   * @param {any} inbound_email_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_conductor_inbound_email_reroute_path: __route({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"reroute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/conductor/action_mailbox/inbound_emails/sources(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_conductor_inbound_email_sources_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/conductor/action_mailbox/inbound_emails(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_conductor_inbound_emails_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/active_storage/direct_uploads(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_direct_uploads_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/active_storage/disk/:encoded_key/*filename(.:format)
   * @param {any} encoded_key
   * @param {any} filename
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_disk_service_path: __route({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/action_mailbox/mailgun/inbound_emails/mime(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_mailgun_inbound_emails_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"mime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/action_mailbox/mandrill/inbound_emails(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_mandrill_inbound_emails_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/action_mailbox/mandrill/inbound_emails(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_mandrill_inbound_health_check_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/action_mailbox/postmark/inbound_emails(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_postmark_inbound_emails_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/action_mailbox/relay/inbound_emails(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_relay_inbound_emails_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"relay"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/action_mailbox/sendgrid/inbound_emails(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_sendgrid_inbound_emails_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"sendgrid"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
   * @param {any} signed_id
   * @param {any} filename
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_service_blob_path: __route({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
   * @param {any} signed_id
   * @param {any} filename
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_service_blob_proxy_path: __route({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /recaptcha/test(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  recaptcha_test_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"recaptcha"],[2,[7,"/"],[2,[6,"test"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/receive_instance_drain(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  receive_instance_drain_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"receive_instance_drain"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/receiving_domains/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  receiving_domain_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"receiving_domains"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/receiving_domains/:receiving_domain_id/mailboxes/:id(.:format)
   * @param {any} receiving_domain_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  receiving_domain_mailbox_path: __route({"receiving_domain_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"receiving_domains"],[2,[7,"/"],[2,[3,"receiving_domain_id"],[2,[7,"/"],[2,[6,"mailboxes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/receiving_domains/:receiving_domain_id/mailboxes(.:format)
   * @param {any} receiving_domain_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  receiving_domain_mailboxes_path: __route({"receiving_domain_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"receiving_domains"],[2,[7,"/"],[2,[3,"receiving_domain_id"],[2,[7,"/"],[2,[6,"mailboxes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/receiving_domains(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  receiving_domains_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"receiving_domains"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/receiving_domains/:id/recheck_dns(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  recheck_dns_eui_receiving_domain_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"receiving_domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"recheck_dns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/sending_domains/:id/recheck_dns(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  recheck_dns_eui_sending_domain_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"sending_domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"recheck_dns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/shared_tracking_domains/:id/recheck_dns(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  recheck_dns_eui_shared_tracking_domain_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"shared_tracking_domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"recheck_dns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/relay_servers/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  relay_server_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"relay_servers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/relay_servers/:relay_server_id/used_by(.:format)
   * @param {any} relay_server_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  relay_server_used_by_index_path: __route({"relay_server_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"relay_servers"],[2,[7,"/"],[2,[3,"relay_server_id"],[2,[7,"/"],[2,[6,"used_by"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/relay_servers(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  relay_servers_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"relay_servers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/organizations/:id/remove_sending_credits(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  remove_sending_credits_api_organization_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_sending_credits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/organizations/:id/remove_sending_credits(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  remove_sending_credits_api_v2_organization_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_sending_credits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/users/:id/remove_two_factor_authentication(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  remove_two_factor_authentication_eui_user_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_two_factor_authentication"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /users/:id/remove_two_factor_authentication(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  remove_two_factor_authentication_user_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_two_factor_authentication"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /segmentation_criterias/render_criteria(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  render_criteria_segmentation_criterias_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"segmentation_criterias"],[2,[7,"/"],[2,[6,"render_criteria"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/autoresponders/render_delay_settings(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  render_delay_settings_mailing_list_autoresponders_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"autoresponders"],[2,[7,"/"],[2,[6,"render_delay_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /tools/render_html_preview(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  render_html_preview_tools_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"render_html_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /api/campaigns/:id/render_preview(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  render_preview_api_campaign_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"render_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/campaigns/:id/render_preview(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  render_preview_api_v2_campaign_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"render_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/render_template_settings(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  render_template_settings_campaigns_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[6,"render_template_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/autoresponders/render_trigger_settings(.:format)
   * @param {any} mailing_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  render_trigger_settings_mailing_list_autoresponders_path: __route({"mailing_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"autoresponders"],[2,[7,"/"],[2,[6,"render_trigger_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:campaign_id/contents/:content_id/preview_render(.:format)
   * @param {any} campaign_id
   * @param {any} content_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  request_new_render_path: __route({"campaign_id":{"r":true},"content_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"campaign_id"],[2,[7,"/"],[2,[6,"contents"],[2,[7,"/"],[2,[3,"content_id"],[2,[7,"/"],[2,[6,"preview_render"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mui/sub_accounts/:sub_account_id/user_roles/:id/resend_link(.:format)
   * @param {any} sub_account_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  resend_link_mui_sub_account_user_role_path: __route({"sub_account_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mui"],[2,[7,"/"],[2,[6,"sub_accounts"],[2,[7,"/"],[2,[3,"sub_account_id"],[2,[7,"/"],[2,[6,"user_roles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend_link"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mui/user_roles/:id/resend_link(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  resend_link_mui_user_role_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mui"],[2,[7,"/"],[2,[6,"user_roles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend_link"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /users/:id/reset_lockout(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  reset_lockout_user_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset_lockout"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/users/:id/reset_password_failure_lockout(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  reset_password_failure_lockout_api_user_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset_password_failure_lockout"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/users/:id/reset_password_failure_lockout(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  reset_password_failure_lockout_api_v2_user_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reset_password_failure_lockout"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /resque
   * @param {object | undefined} options
   * @returns {string} route path
   */
  resque_server_path: __route({}, [2,[7,"/"],[6,"resque"]]),

  /**
   * Generates rails route to
   * /api/campaigns/:id/resume(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  resume_api_campaign_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resume"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/campaigns/:id/resume(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  resume_api_mailing_list_campaign_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resume"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/campaigns/:id/resume(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  resume_api_v2_campaign_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resume"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/campaigns/:id/resume(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  resume_api_v2_mailing_list_campaign_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resume"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /
   * @param {object | undefined} options
   * @returns {string} route path
   */
  root_path: __route({}, [7,"/"]),

  /**
   * Generates rails route to
   * /api/v3/eng/routes/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  route_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"routes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/routes(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  routes_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"routes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/routing_rules/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  routing_rule_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"routing_rules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/routing_rules/:routing_rule_id/domain_overrides/:id(.:format)
   * @param {any} routing_rule_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  routing_rule_routing_rule_domain_override_path: __route({"routing_rule_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"routing_rules"],[2,[7,"/"],[2,[3,"routing_rule_id"],[2,[7,"/"],[2,[6,"domain_overrides"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/routing_rules/:routing_rule_id/domain_overrides(.:format)
   * @param {any} routing_rule_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  routing_rule_routing_rule_domain_overrides_path: __route({"routing_rule_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"routing_rules"],[2,[7,"/"],[2,[3,"routing_rule_id"],[2,[7,"/"],[2,[6,"domain_overrides"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/routing_rules/:routing_rule_id/used_by(.:format)
   * @param {any} routing_rule_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  routing_rule_used_by_index_path: __route({"routing_rule_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"routing_rules"],[2,[7,"/"],[2,[3,"routing_rule_id"],[2,[7,"/"],[2,[6,"used_by"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/routing_rules(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  routing_rules_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"routing_rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /seed_lists/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  seed_list_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"seed_lists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /seed_lists(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  seed_lists_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"seed_lists"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /segmentation_criterias/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  segmentation_criteria_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"segmentation_criterias"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /segmentation_criterias(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  segmentation_criterias_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"segmentation_criterias"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /api/autoresponders/:id/send_preview(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  send_preview_api_autoresponder_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"autoresponders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/campaigns/:id/send_preview(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  send_preview_api_campaign_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/autoresponders/:id/send_preview(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  send_preview_api_v2_autoresponder_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"autoresponders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/campaigns/:id/send_preview(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  send_preview_api_v2_campaign_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/organizations/:id/sending_credits(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  sending_credits_api_organization_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sending_credits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/organizations/:id/sending_credits(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  sending_credits_api_v2_organization_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sending_credits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/sending_domains/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  sending_domain_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"sending_domains"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/sending_domains(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  sending_domains_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"sending_domains"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/incoming_email_domains/default_bounce_mailbox(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  set_default_bounce_mailbox_incoming_email_domains_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"incoming_email_domains"],[2,[7,"/"],[2,[6,"default_bounce_mailbox"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/url_domains/default(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  set_default_url_domains_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"url_domains"],[2,[7,"/"],[2,[6,"default"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/virtual_mtas/default(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  set_default_virtual_mtas_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"virtual_mtas"],[2,[7,"/"],[2,[6,"default"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/organizations/:id/set_sending_credits(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  set_sending_credits_api_organization_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"set_sending_credits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/organizations/:id/set_sending_credits(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  set_sending_credits_api_v2_organization_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"set_sending_credits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/shared_tracking_domains/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  shared_tracking_domain_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"shared_tracking_domains"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/shared_tracking_domains(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  shared_tracking_domains_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"shared_tracking_domains"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /bee-fs/:bee_path(.:format)
   * @param {any} bee_path
   * @param {object | undefined} options
   * @returns {string} route path
   */
  show_image_or_directory_path: __route({"bee_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bee-fs"],[2,[7,"/"],[2,[3,"bee_path"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /statistics/:statistic_id/engine/smtp_drilldown(.:format)
   * @param {any} statistic_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  smtp_drilldown_statistic_engine_path: __route({"statistic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"statistics"],[2,[7,"/"],[2,[3,"statistic_id"],[2,[7,"/"],[2,[6,"engine"],[2,[7,"/"],[2,[6,"smtp_drilldown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /special_sending_rules/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  special_sending_rule_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"special_sending_rules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /special_sending_rules/:special_sending_rule_id/previews/:id(.:format)
   * @param {any} special_sending_rule_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  special_sending_rule_preview_path: __route({"special_sending_rule_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"special_sending_rules"],[2,[7,"/"],[2,[3,"special_sending_rule_id"],[2,[7,"/"],[2,[6,"previews"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /special_sending_rules/:special_sending_rule_id/previews(.:format)
   * @param {any} special_sending_rule_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  special_sending_rule_previews_path: __route({"special_sending_rule_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"special_sending_rules"],[2,[7,"/"],[2,[3,"special_sending_rule_id"],[2,[7,"/"],[2,[6,"previews"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /special_sending_rules(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  special_sending_rules_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"special_sending_rules"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /statistics/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  statistic_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"statistics"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /statistics/:statistic_id/bounces/:id(.:format)
   * @param {any} statistic_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  statistic_bounce_path: __route({"statistic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"statistics"],[2,[7,"/"],[2,[3,"statistic_id"],[2,[7,"/"],[2,[6,"bounces"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /statistics/:statistic_id/bounces(.:format)
   * @param {any} statistic_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  statistic_bounces_path: __route({"statistic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"statistics"],[2,[7,"/"],[2,[3,"statistic_id"],[2,[7,"/"],[2,[6,"bounces"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /statistics/:statistic_id/clicks(.:format)
   * @param {any} statistic_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  statistic_clicks_path: __route({"statistic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"statistics"],[2,[7,"/"],[2,[3,"statistic_id"],[2,[7,"/"],[2,[6,"clicks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:id/campaign_statistics_compare(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  statistic_compare_mailing_list_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"campaign_statistics_compare"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /statistics/:statistic_id/engine(.:format)
   * @param {any} statistic_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  statistic_engine_path: __route({"statistic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"statistics"],[2,[7,"/"],[2,[3,"statistic_id"],[2,[7,"/"],[2,[6,"engine"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /statistics/:statistic_id/link_counts(.:format)
   * @param {any} statistic_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  statistic_link_counts_path: __route({"statistic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"statistics"],[2,[7,"/"],[2,[3,"statistic_id"],[2,[7,"/"],[2,[6,"link_counts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:id/campaign_statistics(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  statistic_mailing_list_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"campaign_statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /statistics/:statistic_id/opens(.:format)
   * @param {any} statistic_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  statistic_opens_path: __route({"statistic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"statistics"],[2,[7,"/"],[2,[3,"statistic_id"],[2,[7,"/"],[2,[6,"opens"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /statistics/:statistic_id/scomps(.:format)
   * @param {any} statistic_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  statistic_scomps_path: __route({"statistic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"statistics"],[2,[7,"/"],[2,[3,"statistic_id"],[2,[7,"/"],[2,[6,"scomps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /statistics/:statistic_id/skips/:id(.:format)
   * @param {any} statistic_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  statistic_skip_path: __route({"statistic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"statistics"],[2,[7,"/"],[2,[3,"statistic_id"],[2,[7,"/"],[2,[6,"skips"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /statistics/:statistic_id/skips(.:format)
   * @param {any} statistic_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  statistic_skips_path: __route({"statistic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"statistics"],[2,[7,"/"],[2,[3,"statistic_id"],[2,[7,"/"],[2,[6,"skips"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /statistics/:statistic_id/unsubs(.:format)
   * @param {any} statistic_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  statistic_unsubs_path: __route({"statistic_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"statistics"],[2,[7,"/"],[2,[3,"statistic_id"],[2,[7,"/"],[2,[6,"unsubs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/autoresponders/:id/statistics(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  statistics_api_mailing_list_autoresponder_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"autoresponders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/autoresponders/:id/statistics(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  statistics_api_v2_mailing_list_autoresponder_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"autoresponders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/home/statistics(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  statistics_eui_home_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"home"],[2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:id/stats_summary(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  stats_summary_campaign_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"stats_summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /subscriber_imports/:id/status(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  status_subscriber_import_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscriber_imports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mui/sub_accounts/stop_sudo(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  stop_sudo_mui_sub_accounts_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"mui"],[2,[7,"/"],[2,[6,"sub_accounts"],[2,[7,"/"],[2,[6,"stop_sudo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /suppression_lists/:id/stream(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  stream_suppression_list_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"suppression_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"stream"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /subscriber_exports/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  subscriber_export_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscriber_exports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /subscriber_exports(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  subscriber_exports_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"subscriber_exports"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /special_sending_rules/:special_sending_rule_id/previews/subscriber_form_fields(.:format)
   * @param {any} special_sending_rule_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  subscriber_form_fields_special_sending_rule_previews_path: __route({"special_sending_rule_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"special_sending_rules"],[2,[7,"/"],[2,[3,"special_sending_rule_id"],[2,[7,"/"],[2,[6,"previews"],[2,[7,"/"],[2,[6,"subscriber_form_fields"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /subscriber_imports/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  subscriber_import_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscriber_imports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /subscriber_imports(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  subscriber_imports_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"subscriber_imports"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:id/subscribers_count(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  subscribers_count_api_mailing_list_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"subscribers_count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:id/subscribers_count(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  subscribers_count_api_v2_mailing_list_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"subscribers_count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /subscribers/search_by_email(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  subscribers_search_by_email_index_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[6,"search_by_email"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /subscription_web_forms/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  subscription_web_form_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscription_web_forms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /subscription_web_forms(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  subscription_web_forms_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"subscription_web_forms"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /sudo/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  sudo_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sudo"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /sudo(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  sudo_index_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"sudo"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /mui/sub_accounts/:id/sudo(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  sudo_mui_sub_account_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mui"],[2,[7,"/"],[2,[6,"sub_accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sudo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:id/summary(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  summary_campaign_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /suppressed_addresses/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  suppressed_address_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"suppressed_addresses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /suppressed_address_imports/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  suppressed_address_import_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"suppressed_address_imports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /suppressed_address_imports(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  suppressed_address_imports_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"suppressed_address_imports"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /suppressed_addresses(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  suppressed_addresses_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"suppressed_addresses"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /suppression_lists/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  suppression_list_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"suppression_lists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /suppression_lists/:suppression_list_id/suppressed_addresses/:id(.:format)
   * @param {any} suppression_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  suppression_list_suppressed_address_path: __route({"suppression_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"suppression_lists"],[2,[7,"/"],[2,[3,"suppression_list_id"],[2,[7,"/"],[2,[6,"suppressed_addresses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /suppression_lists/:suppression_list_id/suppressed_address_imports/:id(.:format)
   * @param {any} suppression_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  suppression_list_suppressed_address_import_path: __route({"suppression_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"suppression_lists"],[2,[7,"/"],[2,[3,"suppression_list_id"],[2,[7,"/"],[2,[6,"suppressed_address_imports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /suppression_lists/:suppression_list_id/suppressed_address_imports/:suppressed_address_import_id/destroy(.:format)
   * @param {any} suppression_list_id
   * @param {any} suppressed_address_import_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  suppression_list_suppressed_address_import_destroy_path: __route({"suppression_list_id":{"r":true},"suppressed_address_import_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"suppression_lists"],[2,[7,"/"],[2,[3,"suppression_list_id"],[2,[7,"/"],[2,[6,"suppressed_address_imports"],[2,[7,"/"],[2,[3,"suppressed_address_import_id"],[2,[7,"/"],[2,[6,"destroy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /suppression_lists/:suppression_list_id/suppressed_address_imports(.:format)
   * @param {any} suppression_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  suppression_list_suppressed_address_imports_path: __route({"suppression_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"suppression_lists"],[2,[7,"/"],[2,[3,"suppression_list_id"],[2,[7,"/"],[2,[6,"suppressed_address_imports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /suppression_lists/:suppression_list_id/suppressed_addresses(.:format)
   * @param {any} suppression_list_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  suppression_list_suppressed_addresses_path: __route({"suppression_list_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"suppression_lists"],[2,[7,"/"],[2,[3,"suppression_list_id"],[2,[7,"/"],[2,[6,"suppressed_addresses"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /suppression_lists(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  suppression_lists_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"suppression_lists"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /system_config(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  system_config_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"system_config"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/eng_throttles/:id/take_out_of_backoff(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  take_out_of_backoff_eui_virtual_mta_eng_throttle_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"eng_throttles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"take_out_of_backoff"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/ip_addresses/:ip_address_id/throttles/:id/take_out_of_backoff(.:format)
   * @param {any} ip_address_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  take_out_of_backoff_ip_address_throttle_path: __route({"ip_address_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"ip_addresses"],[2,[7,"/"],[2,[3,"ip_address_id"],[2,[7,"/"],[2,[6,"throttles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"take_out_of_backoff"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /templates/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  template_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /templates(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  templates_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"templates"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /bee_callback/test_new_api_key(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  test_new_api_key_bee_callback_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"bee_callback"],[2,[7,"/"],[2,[6,"test_new_api_key"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /edm_designer_callback/test_new_api_key(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  test_new_api_key_edm_designer_callback_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"edm_designer_callback"],[2,[7,"/"],[2,[6,"test_new_api_key"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /suppression_lists/:id/test(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  test_suppression_list_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"suppression_lists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"test"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/throttle_programs/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  throttle_program_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"throttle_programs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/throttle_programs/:throttle_program_id/used_by(.:format)
   * @param {any} throttle_program_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  throttle_program_throttle_program_references_path: __route({"throttle_program_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"throttle_programs"],[2,[7,"/"],[2,[3,"throttle_program_id"],[2,[7,"/"],[2,[6,"used_by"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/throttle_programs(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  throttle_programs_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"throttle_programs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/throttles_in_backoff(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  throttles_in_backoff_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"throttles_in_backoff"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/throttling_templates/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  throttling_template_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"throttling_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/throttling_templates/:throttling_template_id/used_by(.:format)
   * @param {any} throttling_template_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  throttling_template_throttling_template_references_path: __route({"throttling_template_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"throttling_templates"],[2,[7,"/"],[2,[3,"throttling_template_id"],[2,[7,"/"],[2,[6,"used_by"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/throttling_templates/:throttling_template_id/throttling_rules/:id(.:format)
   * @param {any} throttling_template_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  throttling_template_throttling_template_rule_path: __route({"throttling_template_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"throttling_templates"],[2,[7,"/"],[2,[3,"throttling_template_id"],[2,[7,"/"],[2,[6,"throttling_rules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/throttling_templates/:throttling_template_id/throttling_rules(.:format)
   * @param {any} throttling_template_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  throttling_template_throttling_template_rules_path: __route({"throttling_template_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"throttling_templates"],[2,[7,"/"],[2,[3,"throttling_template_id"],[2,[7,"/"],[2,[6,"throttling_rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/throttling_templates(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  throttling_templates_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"throttling_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /tools/toggle_quick_tips(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  toggle_quick_tips_tools_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[6,"toggle_quick_tips"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /campaigns/:id/toggle_v1_editor(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  toggle_v1_editor_campaign_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_v1_editor"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /tools/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  tool_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tools"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /tools(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  tools_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"tools"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/subscribers/:id/trigger_autoresponders(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  trigger_autoresponders_api_mailing_list_subscriber_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"trigger_autoresponders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/subscribers/:id/trigger_autoresponders(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  trigger_autoresponders_api_v2_mailing_list_subscriber_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"trigger_autoresponders"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /two_factor_authentications(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  two_factor_authentications_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"two_factor_authentications"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /eui/user_sessions/two_factor(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  two_factor_eui_user_sessions_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"user_sessions"],[2,[7,"/"],[2,[6,"two_factor"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /user_session/two_factor(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  twofactor_post_user_session_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"user_session"],[2,[7,"/"],[2,[6,"two_factor"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /api/jobs/unfinished(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  unfinished_api_jobs_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"unfinished"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/organizations/:organization_id/jobs/unfinished(.:format)
   * @param {any} organization_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  unfinished_api_organization_jobs_path: __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"unfinished"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/jobs/unfinished(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  unfinished_api_v2_jobs_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"unfinished"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/organizations/:organization_id/jobs/unfinished(.:format)
   * @param {any} organization_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  unfinished_api_v2_organization_jobs_path: __route({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"unfinished"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/jobs/unfinished_on_all_organizations(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  unfinished_on_all_organizations_api_jobs_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"unfinished_on_all_organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/jobs/unfinished_on_all_organizations(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  unfinished_on_all_organizations_api_v2_jobs_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"unfinished_on_all_organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/mailing_lists/:mailing_list_id/autoresponders/:id/unpause(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  unpause_api_mailing_list_autoresponder_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"autoresponders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unpause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/subscriber_imports/:id/unpause(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  unpause_api_subscriber_import_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"subscriber_imports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unpause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/mailing_lists/:mailing_list_id/autoresponders/:id/unpause(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  unpause_api_v2_mailing_list_autoresponder_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"autoresponders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unpause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/subscriber_imports/:id/unpause(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  unpause_api_v2_subscriber_import_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"subscriber_imports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unpause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/paused_domains/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  unpause_domain_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"paused_domains"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/paused_domains/:id/unpause(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  unpause_eui_virtual_mta_paused_domain_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"paused_domains"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unpause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mailing_lists/:mailing_list_id/autoresponders/:id/unpause(.:format)
   * @param {any} mailing_list_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  unpause_mailing_list_autoresponder_path: __route({"mailing_list_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mailing_lists"],[2,[7,"/"],[2,[3,"mailing_list_id"],[2,[7,"/"],[2,[6,"autoresponders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unpause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /unsubscribe/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  unsub_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"unsubscribe"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /unsubscribe(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  unsubscribe_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"unsubscribe"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /api/subscribers/unsubscribe(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  unsubscribe_api_subscribers_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[6,"unsubscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v2/subscribers/unsubscribe(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  unsubscribe_api_v2_subscribers_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"subscribers"],[2,[7,"/"],[2,[6,"unsubscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/incoming_email_domains/update_default_bounce_address(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_default_bounce_address_eui_incoming_email_domains_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"incoming_email_domains"],[2,[7,"/"],[2,[6,"update_default_bounce_address"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/entities/update_default_route(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_default_route_eui_virtual_mta_entities_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"entities"],[2,[7,"/"],[2,[6,"update_default_route"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/url_domains/update_default_url_domain(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_default_url_domain_eui_url_domains_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"url_domains"],[2,[7,"/"],[2,[6,"update_default_url_domain"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /subscriber_imports/:id/update_field_associations(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_field_associations_subscriber_import_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscriber_imports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_field_associations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /subscriber_imports/:id/update_import_start(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_import_start_subscriber_import_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscriber_imports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_import_start"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/active_storage/disk/:encoded_token(.:format)
   * @param {any} encoded_token
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_rails_disk_service_path: __route({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/url_domains/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  url_domain_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"url_domains"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/url_domains/:url_domain_id/used_by(.:format)
   * @param {any} url_domain_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  url_domain_url_domain_references_path: __route({"url_domain_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"url_domains"],[2,[7,"/"],[2,[3,"url_domain_id"],[2,[7,"/"],[2,[6,"used_by"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/url_domains(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  url_domains_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"url_domains"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/ip_addresses/:id/used_by(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  used_by_eui_virtual_mta_ip_address_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"ip_addresses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"used_by"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/relay_servers/:id/used_by(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  used_by_eui_virtual_mta_relay_server_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"relay_servers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"used_by"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/routing_rules/:id/used_by(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  used_by_eui_virtual_mta_routing_rule_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"routing_rules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"used_by"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /eui/virtual_mta/throttling_templates/:id/used_by(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  used_by_eui_virtual_mta_throttling_template_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"eui"],[2,[7,"/"],[2,[6,"virtual_mta"],[2,[7,"/"],[2,[6,"throttling_templates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"used_by"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /users/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  user_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /user_session(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  user_session_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"user_session"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /users(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  users_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/virtual_mtas/:virtual_mta_id/used_by(.:format)
   * @param {any} virtual_mta_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  virtual_mta_virtual_mta_references_path: __route({"virtual_mta_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"virtual_mtas"],[2,[7,"/"],[2,[3,"virtual_mta_id"],[2,[7,"/"],[2,[6,"used_by"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v3/eng/virtual_mtas(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  virtual_mtas_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v3"],[2,[7,"/"],[2,[6,"eng"],[2,[7,"/"],[2,[6,"virtual_mtas"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /web_forms/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  web_form_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"web_forms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /web_form_delivery_settings/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  web_form_delivery_setting_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"web_form_delivery_settings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /web_form_delivery_settings(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  web_form_delivery_settings_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"web_form_delivery_settings"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /web_forms/:web_form_id/history(.:format)
   * @param {any} web_form_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  web_form_history_path: __route({"web_form_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"web_forms"],[2,[7,"/"],[2,[3,"web_form_id"],[2,[7,"/"],[2,[6,"history"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /web_forms(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  web_forms_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"web_forms"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /web_forms/modify_subscribers/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  web_forms_modify_subscriber_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"web_forms"],[2,[7,"/"],[2,[6,"modify_subscribers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /web_forms/subscriptions/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  web_forms_subscription_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"web_forms"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /web_forms/subscriptions(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  web_forms_subscriptions_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"web_forms"],[2,[7,"/"],[2,[6,"subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /webviews/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  webview_path: __route({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"webviews"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /webviews(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  webviews_path: __route({"format":{}}, [2,[7,"/"],[2,[6,"webviews"],[1,[2,[8,"."],[3,"format"]]]]])}
,
    });
})();
